export default {
  // Rate Query
  rateQuery: {
    title: 'Rate Query',
    description: 'Query FCL, LCL, Air, Pre-port and Last Mile rate information',
    filterTitle: 'Filter Conditions',
    destination: {
      label: 'Place of Delivery',
      placeholder: 'Select place of delivery'
    },
    totalCount: 'Total {count}',
    priceDisplay: {
      mode: 'Price Display',
      numeric: 'Numeric',
      currencyStr: 'Multi-Currency'
    },
    fclCard: {
      carrier: 'Carrier',
      routeInfo: 'Route Information',
      remarks: 'Remarks',
      validPeriod: 'Validity',
      operation: 'Operation',
      dateTo: 'to',
      detail: 'Details',
      schedule: 'Schedule',
      linkConsignment: 'Link Consignment',
      cargoType: 'Cargo Type',
      supplier: 'Supplier:',
      source: {
        inquiry: 'Inquiry',
        bidding: 'Bidding',
        manual: 'Manual',
        system: 'System',
        unknown: 'Unknown Source'
      },
      status: {
        normal: 'Valid',
        expired: 'Expired',
        disabled: 'Disabled',
        unknown: 'Unknown Status'
      }
    },

    rail: {
      filters: {
        pol: 'Origin',
        pod: 'Destination',
        railCompany: 'Rail Company'
      },
      placeholders: {
        pol: 'Select origin',
        pod: 'Select destination',
        railCompany: 'Select rail company',
        select: 'Please select',
        input: 'Please enter',
        startDate: 'Start date',
        endDate: 'End date'
      },
      actions: {
        search: 'Search',
        reset: 'Reset',
        combinationQuery: 'Combination Query',
        viewDetail: 'View Details'
      },
      columns: {
        priceNo: 'Rate No.',
        direction: 'Direction',
        pol: 'Origin',
        pod: 'Destination',
        railCompany: 'Rail Company',
        routeType: 'Route Type',
        containerOwner: 'Container Owner',
        cargoType: 'Cargo Type',
        transportMode: 'Service Type',
        transportTerms: 'Transport Terms',
        exitPort: 'Exit Port',
        directTransit: 'Direct/Transit',
        countryOfDeparture: 'Origin Country',
        cityOfDeparture: 'Origin City',
        countryOfDestination: 'Destination Country',
        cityOfDestination: 'Destination City',
        transitStations: 'Transit Stations',
        supplier: 'Supplier',
        companyIds: 'Office',
        price: 'Price',
        transitDays: 'Transit Days',
        validPeriod: 'Valid Period',
        startDate: 'Start Date',
        endDate: 'End Date',
        status: 'Status',
        actions: 'Actions'
      },
      messages: {
        exportFilename: 'Rail-Rates-Export',
        loadFailed: 'Failed to load rail rates',
        viewDetailFailed: 'Failed to view details',
        exportNotImplemented: 'Export feature coming soon',
        basePrice: 'Base',
        totalRows: '{count} rows total',
        minPrice: 'Min {price}',
        placeholder: '--',
        detailTitle: 'Rail Rate Details',
        notFound: 'Rate information not found',
        surchargeTitle: 'Surcharge',
        byContainerType: 'By Container Type',
        missingId: 'Missing rate ID',
        loadDetailFailed: 'Failed to load rate details',
        confirmExportSelected: 'Export the selected {count} rail rates. The task will run in the background and can be downloaded from Task Center.',
        dayUnit: '{count} days',
        outbound: 'Outbound',
        inbound: 'Inbound',
        railwayBox: 'Railway Box',
        inlandPortBox: 'Inland Port Box',
        crBox: 'CR Box',
        nonCrBox: 'Non-CR Box',
        middleLine: 'Middle Line',
        northLine: 'North Line',
        southLine: 'South Line',
        southeastAsia: 'Southeast Asia',
        centralAsia: 'Central Asia',
        expired: 'Expired',
        disabled: 'Disabled'
      },
      combination: {
        title: 'Combination Query',
        back: 'Back',
        steps: {
          conditions: 'Fill Query Conditions',
          conditionsDesc: 'Configure query parameters',
          rate: 'Select Matching Rate',
          rateDesc: 'Choose a suitable option'
        },
        sections: {
          basic: 'Basic Information',
          loadingAddress: 'Loading Address (Optional)',
          deliveryAddress: 'Last Mile Delivery Address (Optional)',
          rate: 'Select Matching Rate'
        },
        fields: {
          pol: 'POL',
          pod: 'POD',
          route: 'Route',
          carrier: 'Carrier',
          transportType: 'Transport Type',
          provinceCityDistrict: 'Province / City / District',
          detailAddress: 'Detailed Address',
          addressType: 'Address Type',
          countryPostcode: 'Country + Postcode',
          stateCityRegion: 'State / City / Region',
          warehouseCode: 'Warehouse Code'
        },
        placeholders: {
          pol: 'Select POL',
          pod: 'Select POD',
          route: 'Select route',
          carrier: 'Select carrier',
          province: 'Select province',
          city: 'Select city',
          district: 'Select district',
          detailAddress: 'Enter detailed address',
          country: 'Select country',
          postcode: 'Enter postcode',
          state: 'Select state',
          region: 'Select region',
          amazonWarehouse: 'Select Amazon warehouse',
          ecangWarehouse: 'Select Ecang warehouse'
        },
        options: {
          notSpecified: 'Not Specified',
          thirdPartyAddress: 'Third-party Address',
          amazonWarehouse: 'Amazon Warehouse',
          ecangWarehouse: 'Ecang'
        },
        actions: {
          previous: 'Previous',
          next: 'Next',
          query: 'Query'
        },
        messages: {
          apiPending: 'Rail combination query API is not connected yet'
        },
        empty: 'No rail combination options'
      }
    },

    // Tabs
    tabs: {
      fcl: 'FCL Rate',
      lcl: 'LCL Rate',
      air: 'Air Rate',
      precarriage: 'Pre-port Rate',
      oncarriage: 'Last Mile Rate',
      express: 'Express Rate',
      rail: 'Rail Rate'
    },

    // Filters
    filters: {
      carrier: 'Carrier',
      carrierPlaceholder: 'Select carrier',
      validPeriod: 'Validity',
      routeName: 'Route Name',
      routeNamePlaceholder: 'Select route name',
      departurePort: 'POL',
      departurePortPlaceholder: 'Select POL',
      dischargePort: 'POD',
      dischargePortPlaceholder: 'Select POD',
      // Extension filter conditions
      priceNo: 'Rate No.',
      priceNoPlaceholder: 'Please enter rate number',
      rateType: 'Rate Type',
      rateTypePlaceholder: 'Please select rate type',
      status: 'Status',
      statusPlaceholder: 'Please select rate status',
      cargoType: 'Cargo Type',
      cargoTypePlaceholder: 'Please select cargo type',
      routeCategory: 'Route Category',
      routeCategoryPlaceholder: 'Please select route category',
      validStartDate: 'Start Date',
      validEndDate: 'End Date',
      loadingAddress: 'Loading Address',
      deliveryAddress: 'Delivery Address',
      detailAddressPlaceholder: 'Please enter province/city/district/detailed address',
      originWharf: 'Origin Terminal',
      destinationWharf: 'Destination Terminal',
      wharfPlaceholder: 'Please enter terminal name (optional)',
      supplier: 'Supplier',
      contractNo: 'Contract No.',
      contractNoPlaceholder: 'Please select contract number',
      vesselName: 'Vessel',
      vesselNamePlaceholder: 'Please enter vessel name',
      voyageNo: 'Voyage No.',
      voyageNoPlaceholder: 'Please enter voyage number',
      weekdays: 'Vessel Schedule',
      weekdaysPlaceholder: 'Please select vessel schedule',
      transitType: 'Transit Type',
      transitTypePlaceholder: 'Please select transit type',
      spaceStatus: 'Space Status',
      spaceStatusPlaceholder: 'Please select space status',
      transitPort: 'Transit Port',
      transitPortPlaceholder: 'Please select transit port',
      priceTrend: 'Price Trend',
      priceTrendPlaceholder: 'Please select price trend',
      routeCode: 'Route Code',
      routeCodePlaceholder: 'Please enter route code',
      voyageDays: 'Voyage Days',
      voyageDaysPlaceholder: 'Please enter voyage days',
      detentionFreeDays: 'Detention Free Days',
      detentionFreeDaysPlaceholder: 'Please enter detention free days (days)',
      demurrageFreeDays: 'Demurrage Free Days',
      demurrageFreeDaysPlaceholder: 'Please enter demurrage free days (days)',
      nac: 'NAC',
      nacPlaceholder: 'Please select NAC',
      remarks: 'Remarks',
      remarksPlaceholder: 'Please enter remarks',
      createdBy: 'Created By',
      createdByPlaceholder: 'Please enter created by',
      modifiedBy: 'Modified By',
      modifiedByPlaceholder: 'Please enter modified by',
      // Time filters
      beginDate: 'Effective Date',
      beginDatePlaceholder: 'Please select effective date range',
      endDate: 'Expiry Date',
      endDatePlaceholder: 'Please select expiry date range',
      etdRange: 'ETD Range',
      etdRangePlaceholder: 'Please select ETD range',
      etaRange: 'ETA Range',
      etaRangePlaceholder: 'Please select ETA range',
      createTime: 'Create Time',
      createTimePlaceholder: 'Please select creation time range',
      updateTime: 'Update Time',
      updateTimePlaceholder: 'Please select modification time range',
      // Exact matches for fallback search
      selectEffectiveDate: 'Please select effective date',
      selectExpiryDate: 'Please select expiry date',
      enterWharf: 'Please enter wharf',
      selectSupplier: 'Please select supplier',
      selectPortType: 'Please select port type',
      selectDirectTransitExact: 'Please select direct/transit'
    },

    // Options
    options: {
      inquiry: 'Inquiry',
      direct: 'Direct',
      transit: 'Transit',
      // Status options
      enabled: 'Enabled',
      disabled: 'Disabled',
      draft: 'Draft',
      published: 'Published',
      invalid: 'Invalid',
      offline: 'Offline',
      // Rate type options
      contract: 'Contract Price',
      spot: 'SPOT E-commerce',
      // Cargo type options
      general: 'General',
      dangerous: 'Dangerous',
      frozen: 'Frozen',
      special: 'Special',
      steelCoil: 'Steel Coil',
      liquid: 'Liquid',
      chemical: 'Chemical',
      textile: 'Textile',
      // Space status options
      smooth: 'Smooth',
      singleApply: 'Single Apply',
      overbooked: 'Overbooked',
      notAccepting: 'Not Accepting',
      // Price trend options
      rising: 'Rising',
      falling: 'Falling',
      stable: 'Stable',
      // Rate query specific options
      queryStatus: {
        pending: 'Querying',
        completed: 'Completed',
        failed: 'Failed',
        cancelled: 'Cancelled'
      },
      // Combination query solution status
      solutionStatus: {
        available: 'Available',
        unavailable: 'Unavailable',
        pending: 'Pending',
        confirmed: 'Confirmed',
        rejected: 'Rejected'
      },
      // Match level
      matchLevel: {
        excellent: 'Excellent',
        good: 'Good',
        fair: 'Fair',
        poor: 'Poor'
      },
      // Risk level
      riskLevel: {
        low: 'Low Risk',
        medium: 'Medium Risk',
        high: 'High Risk'
      },
      // Feasibility level
      feasibility: {
        highlyFeasible: 'Highly Feasible',
        feasible: 'Feasible',
        partiallyFeasible: 'Partially Feasible',
        notFeasible: 'Not Feasible'
      },
      // Branch line types
      branchLines: {
        zhapu: 'Zhapu Branch',
        wenzhou: 'Wenzhou Branch',
        haining: 'Haining Branch',
        yangzi: 'Yangzi Branch',
        mawei: 'Mawei Branch',
        yiwu: 'Yiwu Sea-Rail',
        huzhou: 'Huzhou Sea-Rail',
        jiujiang: 'Jiujiang Sea-Rail'
      }
    },

    // Routes
    routes: {
      asiaIntra: 'Intra Asia',
      feSea: 'Far East-Southeast Asia',
      feMe: 'Far East-Middle East',
      // Major routes
      transPacific: 'Trans-Pacific',
      transAtlantic: 'Trans-Atlantic',
      europeAsia: 'Europe-Asia',
      mediterranean: 'Mediterranean',
      redSea: 'Red Sea',
      indianOcean: 'Indian Ocean',
      // Regional routes
      northAsia: 'North Asia',
      southeastAsia: 'Southeast Asia',
      southAsia: 'South Asia',
      westAsia: 'West Asia',
      africa: 'Africa',
      australia: 'Australia',
      // Special routes
      arctic: 'Arctic',
      suez: 'Suez Canal',
      panama: 'Panama Canal'
    },

    // Ports
    ports: {
      shanghai: 'Shanghai',
      ningbo: 'Ningbo',
      qingdao: 'Qingdao',
      // China major ports
      xiamen: 'Xiamen',
      guangzhou: 'Guangzhou',
      shenzhen: 'Shenzhen',
      tianjin: 'Tianjin',
      dalian: 'Dalian',
      yantai: 'Yantai',
      lianyungang: 'Lianyungang',
      // Asia major ports
      busan: 'Busan',
      tokyo: 'Tokyo',
      yokohama: 'Yokohama',
      singapore: 'Singapore',
      portKlang: 'Port Klang',
      laemChabang: 'Laem Chabang',
      // Europe major ports
      rotterdam: 'Rotterdam',
      hamburg: 'Hamburg',
      antwerp: 'Antwerp',
      leHavre: 'Le Havre',
      // America major ports
      losAngeles: 'Los Angeles',
      longBeach: 'Long Beach',
      newYork: 'New York',
      savannah: 'Savannah'
    },

    // Carriers
    carriers: {
      msc: 'MSC',
      maersk: 'MAERSK',
      cmaCgm: 'CMA CGM',
      cosco: 'COSCO',
      evergreen: 'EVERGREEN',
      yangMing: 'YANG MING',
      hmm: 'HMM',
      one: 'ONE',
      zim: 'ZIM',
      hpl: 'HAPAG-LLOYD',
      hplQq: 'Hapag-Lloyd QQ',
      hplSpot: 'Hapag-Lloyd Spot',
      oocl: 'OOCL',
      pil: 'PIL',
      csc: 'CSCL',
      cz: 'China Southern',
      mu: 'China Eastern',
      ca: 'Air China',
      ci: 'China Airlines'
    },

    // Currencies
    currencies: {
      usd: 'USD',
      cny: 'CNY',
      eur: 'EUR',
      jpy: 'JPY',
      gbp: 'GBP',
      hkd: 'HKD',
      sgd: 'SGD',
      krw: 'KRW',
      thb: 'THB',
      myr: 'MYR',
      idr: 'IDR',
      php: 'PHP'
    },

    // Billing Units
    billingUnits: {
      teu: 'TEU',
      cbm: 'CBM',
      kgs: 'KGS',
      pcs: 'PCS',
      set: 'SET',
      pallet: 'Pallet',
      container: 'Container',
      ton: 'Ton',
      meter: 'Meter',
      square: 'Square'
    },

    // Charge Items
    chargeItems: {
      oceanFreight: 'Ocean Freight',
      thc: 'THC',
      doc: 'Documentation Fee',
      seal: 'Seal Fee',
      baf: 'BAF',
      caf: 'CAF',
      ebs: 'EBS',
      ccs: 'CCS',
      portCharges: 'Port Charges',
      terminalHandling: 'Terminal Handling',
      wharfage: 'Wharfage',
      customsClearance: 'Customs Clearance',
      inspection: 'Inspection Fee',
      insurance: 'Insurance',
      storage: 'Storage Fee'
    },

    // Container Types
    containerTypes: {
      gp20: '20GP',
      gp40: '40GP',
      hc40: '40HC',
      hc45: '45HC',
      rf20: '20RF',
      rf40: '40RF',
      tk20: '20TK',
      tk40: '40TK',
      ot20: '20OT',
      ot40: '40OT',
      fr20: '20FR',
      fr40: '40FR',
      nor20: '20NOR',
      nor40: '40NOR',
      flat20: '20FLAT',
      flat40: '40FLAT'
    },

    // Weekdays
    weekdays: {
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat',
      sunday: 'Sun',
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
      sun: 'Sun'
    },

    // Pagination
    pagination: {
      total: 'Total {total}',
      pageSize: '{pageSize} / page',
      current: 'Page {current}',
      goto: 'Go to',
      page: 'Page',
      of: 'of',
      items: 'items',
      showTotal: 'Showing {start} to {end} of {total} items',
      showSizeChanger: 'Show size',
      showQuickJumper: 'Quick jump',
      showLessItems: 'Less',
      showMoreItems: 'More'
    },

    // Export
    export: {
      title: 'Export Data',
      filename: 'Rate_Query_Results',
      format: 'Export Format',
      excel: 'Excel',
      csv: 'CSV',
      pdf: 'PDF',
      allColumns: 'All Columns',
      selectedColumns: 'Selected Columns',
      customColumns: 'Custom Columns',
      download: 'Download',
      cancel: 'Cancel',
      processing: 'Exporting...',
      success: 'Export successful',
      failed: 'Export failed'
    },

    // Table operations
    table: {
      toolbar: {
        refresh: 'Refresh',
        density: 'Density',
        columnSetting: 'Column Setting',
        fullScreen: 'Full Screen',
        exitFullScreen: 'Exit Full Screen',
        reload: 'Reload',
        export: 'Export',
        import: 'Import',
        print: 'Print'
      },
      rowActions: {
        view: 'View',
        edit: 'Edit',
        delete: 'Delete',
        copy: 'Copy',
        enable: 'Enable',
        disable: 'Disable',
        more: 'More'
      },
      batchActions: {
        selectAll: 'Select All',
        unselectAll: 'Unselect All',
        selectedCount: '{count} selected',
        batchDelete: 'Batch Delete',
        batchEnable: 'Batch Enable',
        batchDisable: 'Batch Disable',
        batchExport: 'Batch Export'
      }
    },

    // Search and Filters
    search: {
      searchBox: {
        placeholder: 'Enter keywords to search',
        searchButton: 'Search',
        clearButton: 'Clear',
        advancedSearch: 'Advanced Search',
        simpleSearch: 'Simple Search'
      },
      advancedFilter: {
        title: 'Advanced Filter',
        expand: 'Expand',
        collapse: 'Collapse',
        addCondition: 'Add Condition',
        removeCondition: 'Remove Condition',
        clearAll: 'Clear All',
        apply: 'Apply',
        reset: 'Reset',
        saveAsDefault: 'Save as Default',
        loadDefault: 'Load Default'
      },
      filterConditions: {
        and: 'AND',
        or: 'OR',
        equals: 'Equals',
        notEquals: 'Not Equals',
        contains: 'Contains',
        notContains: 'Not Contains',
        startsWith: 'Starts With',
        endsWith: 'Ends With',
        greaterThan: 'Greater Than',
        greaterThanOrEqual: 'Greater Than or Equal',
        lessThan: 'Less Than',
        lessThanOrEqual: 'Less Than or Equal',
        between: 'Between',
        in: 'In',
        notIn: 'Not In',
        isNull: 'Is Null',
        isNotNull: 'Is Not Null'
      }
    },

    // Status and tips
    status: {
      loading: 'Loading...',
      loaded: 'Loaded',
      loadingFailed: 'Loading failed',
      processing: 'Processing...',
      success: 'Success',
      failed: 'Failed',
      cancelled: 'Cancelled',
      noData: 'No Data',
      emptyData: 'Data is empty',
      partialData: 'Partial data failed to load',
      networkError: 'Network Error',
      serverError: 'Server Error',
      timeout: 'Timeout',
      unauthorized: 'Unauthorized',
      forbidden: 'Forbidden',
      notFound: 'Not Found'
    },

    // Tips
    tips: {
      clickToView: 'Click to view details',
      clickToEdit: 'Click to edit',
      clickToDelete: 'Click to delete',
      clickToEnable: 'Click to enable',
      clickToDisable: 'Click to disable',
      selectItems: 'Please select items',
      selectAtLeastOne: 'Please select at least one item',
      selectMaxItems: 'Maximum {max} items can be selected',
      confirmOperation: 'Are you sure to perform this operation?',
      operationIrreversible: 'This operation is irreversible',
      dataWillBeLost: 'Data will be lost',
      help: 'Help',
      moreInfo: 'More Info',
      contactSupport: 'Contact Support'
    },

    // Date and Time
    dateTime: {
      formats: {
        date: 'YYYY-MM-DD',
        dateTime: 'YYYY-MM-DD HH:mm:ss',
        time: 'HH:mm:ss',
        month: 'YYYY-MM',
        year: 'YYYY'
      },
      labels: {
        today: 'Today',
        yesterday: 'Yesterday',
        tomorrow: 'Tomorrow',
        thisWeek: 'This Week',
        lastWeek: 'Last Week',
        nextWeek: 'Next Week',
        thisMonth: 'This Month',
        lastMonth: 'Last Month',
        nextMonth: 'Next Month',
        thisYear: 'This Year',
        lastYear: 'Last Year',
        nextYear: 'Next Year'
      },
      timeLabels: {
        now: 'Now',
        morning: 'Morning',
        afternoon: 'Afternoon',
        evening: 'Evening',
        night: 'Night'
      },
      relative: {
        justNow: 'Just now',
        minutesAgo: '{minutes}m ago',
        hoursAgo: '{hours}h ago',
        daysAgo: '{days}d ago',
        weeksAgo: '{weeks}w ago',
        monthsAgo: '{months}mo ago',
        yearsAgo: '{years}y ago'
      },
      range: {
        validFrom: 'From {date}',
        validUntil: 'Until {date}'
      }
    },

    // Errors
    errors: {
      general: {
        unknown: 'Unknown Error',
        systemError: 'System Error',
        networkError: 'Network Error',
        serverError: 'Server Error',
        clientError: 'Client Error',
        timeout: 'Timeout',
        connectionFailed: 'Connection Failed'
      },
      data: {
        invalidData: 'Invalid Data',
        dataNotFound: 'Data Not Found',
        dataCorrupted: 'Data Corrupted',
        dataIncomplete: 'Data Incomplete',
        dataMismatch: 'Data Mismatch',
        dataExpired: 'Data Expired'
      },
      permission: {
        unauthorized: 'Unauthorized',
        forbidden: 'Forbidden',
        insufficientPrivileges: 'Insufficient Privileges',
        accessDenied: 'Access Denied',
        loginRequired: 'Login Required',
        sessionExpired: 'Session Expired'
      },
      validation: {
        required: 'This field is required',
        invalidFormat: 'Invalid format',
        tooLong: 'Too long',
        tooShort: 'Too short',
        invalidValue: 'Invalid value',
        duplicateValue: 'Duplicate value'
      },
      messages: {
        exportTaskFailed: 'Export task trigger failed',
        selectRecordsFirst: 'Please select records to export first',
        noDataToExport: 'No data to export',
        exportFailed: '{type} export failed'
      }
    },

    // Success
    success: {
      operations: {
        create: 'Created successful',
        update: 'Updated successful',
        delete: 'Deleted successful',
        save: 'Saved successful',
        submit: 'Submitted successful',
        approve: 'Approved successful',
        reject: 'Rejected successful',
        enable: 'Enabled successful',
        disable: 'Disabled successful',
        import: 'Imported successful',
        export: 'Exported successful'
      },
      status: {
        activated: 'Activated',
        deactivated: 'Deactivated',
        published: 'Published',
        unpublished: 'Unpublished',
        archived: 'Archived',
        restored: 'Restored',
        locked: 'Locked',
        unlocked: 'Unlocked'
      },
      messages: {
        operationCompleted: 'Operation completed',
        dataSaved: 'Data saved',
        changesApplied: 'Changes applied',
        settingsUpdated: 'Settings updated',
        configurationSaved: 'Configuration saved',
        exportTaskTriggered: 'Export task triggered. Please check results later.',
        exportSuccess: '{type} export successful, {count} records exported'
      }
    },

    // Confirm dialogs
    confirm: {
      general: {
        title: 'Confirm Operation',
        message: 'Are you sure you want to perform this operation?',
        okText: 'OK',
        cancelText: 'Cancel',
        yesText: 'Yes',
        noText: 'No'
      },
      delete: {
        title: 'Confirm Delete',
        message: 'Are you sure to delete this record?',
        batchMessage: 'Are you sure to delete {count} selected records?',
        warning: 'This action cannot be undone',
        permanent: 'This operation is permanent'
      },
      status: {
        enable: {
          title: 'Confirm Enable',
          message: 'Are you sure to enable this record?',
          batchMessage: 'Are you sure to enable {count} selected records?'
        },
        disable: {
          title: 'Confirm Disable',
          message: 'Are you sure to disable this record?',
          batchMessage: 'Are you sure to disable {count} selected records?'
        }
      },
      save: {
        title: 'Confirm Save',
        message: 'Are you sure to save changes?',
        unsavedChanges: 'You have unsaved changes. Are you sure to leave?',
        discardChanges: 'Are you sure to discard changes?'
      }
    },

    // Help and Settings
    help: {
      menu: {
        help: 'Help',
        userGuide: 'User Guide',
        faq: 'FAQ',
        contactSupport: 'Support',
        about: 'About',
        feedback: 'Feedback'
      },
      userGuide: {
        title: 'User Guide',
        gettingStarted: 'Getting Started',
        basicOperations: 'Basic Operations',
        advancedFeatures: 'Advanced Features',
        troubleshooting: 'Troubleshooting',
        shortcuts: 'Shortcuts'
      },
      faq: {
        title: 'FAQ',
        search: 'Search Problems',
        categories: 'Categories',
        popular: 'Popular Questions',
        recent: 'Recent Questions'
      },
      support: {
        title: 'Contact Support',
        email: 'Email Support',
        phone: 'Phone Support',
        onlineChat: 'Online Chat',
        ticket: 'Ticket System',
        responseTime: 'Response Time'
      }
    },

    settings: {
      basic: {
        title: 'Basic Settings',
        language: 'Language',
        timezone: 'Timezone',
        dateFormat: 'Date Format',
        timeFormat: 'Time Format',
        currency: 'Currency',
        units: 'Units'
      },
      display: {
        title: 'Display Settings',
        theme: 'Theme',
        fontSize: 'Font Size',
        colorScheme: 'Color Scheme',
        layout: 'Layout',
        density: 'Density'
      },
      notification: {
        title: 'Notification Settings',
        email: 'Email',
        sms: 'SMS',
        push: 'Push',
        sound: 'Sound',
        frequency: 'Frequency'
      },
      security: {
        title: 'Security Settings',
        password: 'Password',
        twoFactor: '2FA',
        session: 'Session',
        permissions: 'Permissions',
        audit: 'Audit Log'
      }
    },

    user: {
      management: {
        title: 'User Management',
        userList: 'User List',
        addUser: 'Add User',
        editUser: 'Edit User',
        deleteUser: 'Delete User',
        userProfile: 'User Profile',
        changePassword: 'Change Password'
      },
      roles: {
        title: 'Role Management',
        roleList: 'Role List',
        addRole: 'Add Role',
        editRole: 'Edit Role',
        deleteRole: 'Delete Role',
        assignRole: 'Assign Role',
        permissions: 'Permission Settings'
      },
      permissions: {
        title: 'Permission Management',
        permissionList: 'Permission List',
        addPermission: 'Add Permission',
        editPermission: 'Edit Permission',
        deletePermission: 'Delete Permission',
        assignPermission: 'Assign Permission',
        permissionGroups: 'Permission Groups'
      },
      status: {
        active: 'Active',
        inactive: 'Inactive',
        locked: 'Locked',
        suspended: 'Suspended',
        pending: 'Pending',
        expired: 'Expired'
      }
    },

    reports: {
      management: {
        title: 'Report Management',
        reportList: 'Report List',
        createReport: 'Create Report',
        editReport: 'Edit Report',
        deleteReport: 'Delete Report',
        scheduleReport: 'Schedule Report',
        reportTemplates: 'Templates'
      },
      charts: {
        title: 'Charts',
        lineChart: 'Line Chart',
        barChart: 'Bar Chart',
        pieChart: 'Pie Chart',
        areaChart: 'Area Chart',
        scatterChart: 'Scatter Chart',
        radarChart: 'Radar Chart'
      },
      dimensions: {
        title: 'Dimensions',
        time: 'Time',
        region: 'Region',
        product: 'Product',
        customer: 'Customer',
        channel: 'Channel',
        category: 'Category'
      },
      types: {
        title: 'Types',
        summary: 'Summary',
        detail: 'Detail',
        comparison: 'Comparison',
        trend: 'Trend',
        distribution: 'Distribution',
        custom: 'Custom'
      }
    },

    // ImportExport
    importExport: {
      import: {
        title: 'Data Import',
        selectFile: 'Select File',
        dragDrop: 'Drag and drop file here',
        supportedFormats: 'Supported formats',
        maxFileSize: 'Max file size',
        templateDownload: 'Download Template',
        importPreview: 'Import Preview',
        importProgress: 'Import Progress',
        importResult: 'Import Result'
      },
      export: {
        title: 'Data Export',
        exportFormat: 'Format',
        exportRange: 'Range',
        exportColumns: 'Columns',
        exportFilters: 'Filters',
        exportSchedule: 'Schedule',
        exportHistory: 'History',
        downloadFile: 'Download File'
      },
      formats: {
        excel: 'Excel',
        csv: 'CSV',
        pdf: 'PDF',
        json: 'JSON',
        xml: 'XML',
        txt: 'TXT'
      },
      status: {
        pending: 'Pending',
        processing: 'Processing',
        completed: 'Completed',
        failed: 'Failed',
        cancelled: 'Cancelled',
        partial: 'Partial'
      }
    },

    // Columns
    columns: {
      carrier: 'Carrier',
      dischargePort: 'POD',
      transitType: 'Direct/Transit',
      transit: 'Transit',
      routeCode: 'Route Code',
      vesselName: 'Vessel',
      voyageNo: 'Voyage',
      spaceStatus: 'Space Status',
      remark: 'Remark',
      weight: 'Weight(KGS)',
      volume: 'Volume(CBM)',
      actions: 'Actions',
      status: 'Status',
      createTime: 'Created Time',
      updateTime: 'Updated Time',
      createBy: 'Created By',
      updateBy: 'Updated By',
      priceNo: 'Rate No.',
      rateType: 'Rate Type',
      pol: 'POL',
      pod: 'FND',
      pot: 'Transit Port',
      contractNo: 'Contract No.',
      validPeriod: 'Valid Period',
      etd: 'ETD',
      eta: 'ETA',
      freight: 'Freight',
      currency: 'Currency',
      chargeItem: 'Charge Item',
      billingUnit: 'Unit',
      queryTime: 'Query Time',
      queryUser: 'User',
      queryResult: 'Result',
      matchScore: 'Match Score',
      totalPrice: 'Total Price',
      priceBreakdown: 'Price Breakdown',
      solutionType: 'Solution Type',
      solutionName: 'Solution Name',
      solutionDescription: 'Description',
      feasibility: 'Feasibility',
      estimatedTime: 'EST Time',
      riskLevel: 'Risk Level',
      freeContainerDays: 'Free Container',
      demurrageFreeDays: 'Free Storage',
      overweightRemarks: 'Overweight Remarks',
      receivingInstructions: 'Receiving Instructions'
    },

    // Filter Fields
    filterFields: {
      labels: {
        routeCode: 'Rate No.',
        rateType: 'Rate Type',
        departurePort: 'POL',
        dischargePort: 'FND',
        directTransit: 'Direct/Transit',
        transitPort: 'Transit Port',
        transitType: 'Transit Type',
        shipCompany: 'Carrier',
        contractNo: 'Contract No.',
        spaceStatus: 'Space Status',
        priceStatus: 'Price Trend',
        cargoType: 'Cargo Type',
        vesselSchedule: 'Vessel Schedule',
        voyage: 'Transit Time',
        freeStorageDays: 'Free Container',
        nac: 'NAC',
        validPeriod: 'Validity',
        etd: 'ETD',
        eta: 'ETA',
        vesselName: 'Vessel',
        voyageNo: 'Voyage',
        cutoffDate: 'Closing Date',
        destinationRegion: 'Destination Region',
        entryPerson: 'Created By',
        createDate: 'Created Date',
        rateModifier: 'Modified By',
        modifyDate: 'Modified Date',
        rateStatus: 'Rate Status',
        routeName: 'Route Name',
        routeCodeSelect: 'Route Code',
        terminal: 'Terminal',
        branch: 'Branch'
      },
      placeholders: {
        routeCode: 'Enter rate no.',
        rateType: 'Select rate type',
        departurePort: 'Select POL',
        dischargePort: 'Select FND',
        directTransit: 'Select direct/transit',
        transitPort: 'Select transit port',
        transitType: 'Select transit type',
        shipCompany: 'Select carrier',
        contractNo: 'Select contract no.',
        spaceStatus: 'Select space status',
        priceStatus: 'Select price trend',
        cargoType: 'Select cargo type',
        vesselSchedule: 'Select vessel schedule',
        voyage: 'Enter transit time',
        freeStorageDays: 'Enter free container days',
        nac: 'Select NAC',
        validPeriod: 'Select validity range',
        etd: 'Select ETD range',
        eta: 'Select ETA range',
        vesselName: 'Enter vessel name',
        voyageNo: 'Enter voyage',
        cutoffDate: 'Select closing date range',
        destinationRegion: 'Enter destination region',
        entryPerson: 'Enter created by',
        createDate: 'Select created date range',
        rateModifier: 'Enter modified by',
        modifyDate: 'Select modified date range',
        rateStatus: 'Select rate status',
        routeName: 'Select route name',
        routeCodeSelect: 'Select route code',
        terminal: 'Select terminal',
        branch: 'Select branch'
      }
    },

    // Last Mile Filter Fields
    lastmileFilterFields: {
      labels: {
        priceMethod: 'Rate Type',
        status: 'Rate Status',
        destinationPort: 'POD',
        agent: 'Agent Name',
        currency: 'Currency',
        feeName: 'Fee Name',
        unit: 'Unit',
        addressType: 'Address Type',
        country: 'Country',
        postalCode: 'Postal Code',
        state: 'State',
        city: 'City',
        district: 'District',
        warehouseCode: 'Warehouse Code'
      },
      placeholders: {
        priceMethod: 'Select rate type',
        status: 'Select rate status',
        destinationPort: 'Select POD',
        agent: 'Enter agent name',
        currency: 'Select currency',
        feeName: 'Select fee name',
        unit: 'Select unit',
        addressType: 'Select address type',
        country: 'Select country',
        postalCode: 'Select postal code',
        state: 'Select state',
        city: 'Select city',
        district: 'Select district',
        warehouseCode: 'Enter warehouse code'
      }
    },

    // Actions
    actions: {
      combinationQuery: 'Combination Query',
      batchImport: 'Batch Import',
      export: 'Export List',
      customTable: 'Column Settings',
      download: 'Download',
      copy: 'Copy',
      search: 'Search',
      reset: 'Reset',
      viewDetail: 'Details',
      edit: 'Edit',
      delete: 'Delete',
      enable: 'Enable',
      disable: 'Disable',
      query: 'Query',
      advancedQuery: 'Advanced Query',
      simpleQuery: 'Simple Query',
      saveQuery: 'Save Query',
      loadQuery: 'Load Query',
      clearQuery: 'Clear Query',
      exportQuery: 'Export Results',
      shareQuery: 'Share Query',
      startCombinationQuery: 'Start Combination Query',
      stopCombinationQuery: 'Stop Combination Query',
      saveSolution: 'Save Solution',
      compareSolutions: 'Compare Solutions',
      selectBestSolution: 'Select Best Solution',
      viewDetails: 'View Details',
      addToFavorites: 'Add to Favorites',
      removeFromFavorites: 'Remove from Favorites',
      addToCart: 'Add to Cart',
      removeFromCart: 'Remove from Cart',
      batchOperations: 'Batch Operations ({count})',
      batchOperationsAll: 'Batch Operations',
      batchExportExcel: 'Batch Export Excel',
      batchExportCsv: 'Batch Export CSV',
      exportRate: 'Export Rate ({count})',
      exportRateAll: 'Export Rate',
      batchExport: 'Batch Export',
      confirmExportTitle: 'Confirm Export',
      confirmExportContent: 'Start export task for all rate results under current filters?',
      taskManagerRedirectTitle: 'Export Prompt',
      taskManagerRedirectContent: 'Export task triggered. Check results in Task Center.',
      goToTaskManager: 'Check Tasks',
      quickQuotation: 'Quick Quotation',
      wobaoQuotation: 'WoBao Quotation'
    },

    // Quick Quote
    quickQuotation: {
      title: 'Quick Quotation',
      instruction: 'Modify/copy the text below for quick quotation',
      priceAdjustment: 'Markup original price',
      priceAdjustmentPlaceholder: 'Enter',
      surcharge: 'Surcharge',
      settings: 'Settings',
      cancel: 'Cancel',
      confirm: 'Text Quote',
      copySuccess: 'Quotation text copied to clipboard',
      copyFailed: 'Copy failed, try again',
      fields: {
        carrier: 'Carrier',
        pol: 'POL',
        pod: 'POD',
        etdEta: 'ETD/ETA',
        vesselVoyage: 'Vessel/Voyage',
        routeCode: 'Route Code',
        directTransit: 'Direct/Transit',
        oceanFreight: 'Ocean Freight',
        otherCharges: 'Other Charges',
        surcharge: 'Surcharge'
      },
      customText: {
        title: 'Custom Text Settings',
        instruction: 'Text content here will be shown in quotation',
        enableCustomText: 'Custom Display Text',
        textPosition: 'Position',
        positionTop: 'Top',
        positionBottom: 'Bottom',
        customTextPlaceholder: 'Enter custom text',
        save: 'Save',
        cancel: 'Cancel'
      }
    },

    // Ecommerce Rate Query
    ecommerce: {
      title: 'E-commerce Rate Query',
      filters: {
        pol: 'POL',
        pod: 'Destination Port',
        eta: 'ETA:',
        containerType: 'Box Type',
        carrier: 'Carrier',
        etd: 'ETD',
        etdRange: 'ETD Range',
        direct: 'Direct',
        transit: 'Transit'
      },
      placeholders: {
        pol: 'Select POL',
        pod: 'Select destination port',
        containerType: 'Select box type',
        carrier: 'Select carrier',
        watchMode: 'Select watch mode',
        status: 'Select status',
        input: 'Enter',
        weight: 'KG',
        etdRange: 'Select ETD range'
      },
      actions: {
        ranking: 'Rate Ranking',
        aiAnalysis: 'AI Analysis',
        pin: 'Pin Rate',
        unpin: 'Unpin Rate',
        replacePin: 'Replace Pin',
        quickQuote: 'Quick Quote',
        priceTrend: 'Price Trend',
        arrival: 'Arrival',
        departure: 'Departure',
        aiAnalysisLabel: 'AI Recon',
        batchQuote: 'Batch Quote',
        aiQuote: 'AI Quotation',
        priceWatch: 'Rate Monitor',
        priceWatchSource: 'Based on current query',
        priceWatchTaskSuffix: 'Monitor',
        priceWatchCategoryCarrier: 'Carrier',
        priceWatchCategoryPol: 'POL',
        priceWatchCategoryPod: 'POD',
        // Port names
        priceWatchPorts: {
          cNSHA: 'Shanghai',
          uSLAX: 'Los Angeles',
          uSNYC: 'New York',
          cNYTN: 'Yantian',
          cNSNZ: 'Shenzhen',
          hKHKG: 'Hong Kong',
          cNTXG: 'Tianjin',
          cNQDG: 'Qingdao',
          cNXMN: 'Xiamen',
          cNDLC: 'Dalian',
          cNNGB: 'Ningbo',
          cNLJG: 'Lianyungang',
          cNSZX: 'Shenzhen',
          cNGZO: 'Guangzhou',
          uSLGB: 'Long Beach',
          uSOAK: 'Oakland',
          nLRTM: 'Rotterdam',
          dEHAM: 'Hamburg',
          gBFXT: 'Felixstowe'
        },
        excelImport: 'Excel Import',
        viewWatchTasks: 'Monitor Tasks'
      },
      labels: {
        pinnedRates: 'Pinned Rates',
        allLoaded: 'All content loaded',
        loadingMore: 'Loading...',
        day: 'Days',
        receiving: 'Receiving',
        vessel: 'Vessel',
        voyage: 'Voyage',
        lane: 'Lane',
        basePrice: 'Base Freight',
        totalPrice: 'Total Freight',
        departure: 'Departure',
        arrival: 'Arrival',
        origin: 'Origin',
        destination: 'Destination'
      },
      sort: {
        earliest: 'Earliest',
        fastest: 'Fastest',
        cheapest: 'Cheapest'
      },
      columns: {
        id: 'Rate ID',
        carrierName: 'Carrier Name',
        pol: 'POL',
        pod: 'Destination Port',
        transportTerms: 'Terms',
        laneCode: 'Route Code',
        etd: 'ETD',
        eta: 'ETA',
        transitType: 'Transit',
        validFrom: 'Valid From',
        validTo: 'Valid To',
        spaceStatus: 'Space',
        cargoType: 'Cargo Type',
        transitTime: 'Transit Time',
        totalPrice: 'Total Price',
        totalCurrency: 'Total Cur',
        basePrice: 'Base Price',
        baseCurrency: 'Base Cur',
        vesselName: 'Vessel',
        voyageNo: 'Voyage',
        updateTime: 'Updated',
        surchargeLabel: 'Surcharge Label',
        surchargeAmount: 'Surcharge Amt',
        cutoffDate: 'Closing Date',
        actions: 'Actions'
      },
      freshness: {
        unknown: 'Unknown',
        unknownTime: 'Unknown Time',
        veryFresh: 'Very Fresh',
        fresh: 'Fresh',
        relativelyFresh: 'New',
        withinOneDay: '< 1 day',
        withinTwoDays: '< 2 days',
        stale: 'Old',
        minutesAgo: 'Updated {minutes}m ago',
        hoursAgo: 'Updated {hours}h ago',
        daysAgo: 'Updated {days}d ago'
      },
      quickQuote: {
        title: 'Quick Quote',
        cancel: 'Cancel',
        save: 'Save',
        tips: 'Modify/copy text below for quick quotation',
        record: 'Record',
        recordIndex: 'Record {index}',
        surchargeDetail: '[Surcharge Details]',
        surchargeHeader: 'Category    Fee Name    Payment    Unit    Currency    Price',
        totalEstimate: 'Total: {currency} {amount} (Estimated)',
        customText: {
          title: 'Custom Text Settings',
          info: 'Content here will show in quotation text',
          enable: 'Custom Display Text',
          position: 'Position',
          top: 'Top',
          bottom: 'Bottom',
          default: 'Rates as below. Valid until end of month.',
          aiCopy: 'AI Content',
          generate: 'Generate',
          styles: {
            concise: 'Concise',
            professional: 'Professional',
            friendly: 'Friendly'
          }
        },
        additionalFees: 'Surcharges',
        basicOceanFreight: 'Base Freight',
        totalRate: 'Total Rate',
        fixedPriceMarkup: 'Fixed Price Markup',
        unifiedMarkup: 'Markup all box types:',
        baseMarkup: 'Base Markup',
        totalMarkup: 'Total Markup',
        fixedRatioMarkup: 'Fixed Ratio Markup',
        unifiedRatioMarkup: 'Markup all box types (%):',
        baseRatioMarkup: 'Base Markup %',
        totalRatioMarkup: 'Total Markup %',
        imageQuote: 'Image Quote',
        textQuote: 'Text Quote',
        generatingPreview: 'Generating preview...',
        generatingBatchPreview: 'Generating batch images...',
        aiMarkupSuccess: 'AI batch markup completed',
        copySuccess: '{count} quotes copied to clipboard',
        quoter: 'Quoter',
        validity: 'Validity',
        tabs: {
          aiMarkup: 'AI Markup',
          fixedMarkup: 'Fixed Markup',
          percentMarkup: 'Ratio Markup'
        },
        labels: {
          allContainerMarkup: 'Markup all types:',
          allContainerMarkupPercent: 'Markup all types %:',
          minPrice: 'Min Price:',
          maxPrice: 'Max Price:',
          and: 'and',
          paymentType: 'Payment',
          unit: 'Unit',
          unitBox: 'Per Container',
          por: 'POR',
          fnd: 'FND',
          sailing: 'ETD/ETA',
          vesselVoyage: 'Vessel/Voyage',
          markupLimits: 'Markup Limits',
          validity: 'Validity'
        },
        columns: {
          type: 'Box Type',
          basePrice: 'Base Price',
          totalPrice: 'Total Price',
          markupBase: 'Base Markup',
          markupTotal: 'Total Markup',
          markupBasePercent: 'Base %',
          markupTotalPercent: 'Total %',
          originFee: 'POR Fee',
          destinationFee: 'FND Fee',
          otherFee: 'Other Fee'
        },
        actions: {
          applyAll: 'Apply All',
          copyAll: 'Copy All',
          exportImage: 'Export Image',
          exportAll: 'Export All',
          startAi: 'Start AI'
        },
        strategy: {
          title: 'AI Strategy',
          balance: 'Balanced',
          acquisition: 'Market Priority',
          profit: 'Profit Priority'
        }
      },
      messages: {
        searching: 'Querying...',
        searchFailed: 'Query failed',
        searchInterrupted: 'The query connection was closed. Some carrier results may be missing.',
        carrierNoData: '[{carriers}] No matching data',
        carrierListSeparator: ', ',
        detailNotFound: 'Rate details not found',
        dataNotFound: 'Rate data not found',
        selectRateFirst: 'Select rates first',
        pinSuccess: 'Pinned {count} rates',
        unpinSuccess: 'Unpinned successfully',
        unpinAllSuccess: 'All unpinned',
        unpinCountSuccess: 'Unpinned {count} rates',
        pinFailed: 'Pin failed',
        unpinFailed: 'Unpin failed',
        aiQuoteLimit: 'AI quotation supports a maximum of 10 rates',
        batchQuoteSuccess: 'Batch quote created successfully',
        excelImportSuccess: 'Excel imported successfully',
        aiQuoteSuccess: 'AI quotation generated successfully'
      },
      aiAdvice: {
        title: 'Rate Suggestions',
        subtitle: 'AI Expert Deep Analysis',
        strongSuggest: 'AI Strongly Suggests',
        suggest: 'AI Recommends',
        shortComment: 'Core Comment',
        reason: 'Reason',
        total: 'Total',
        etd: 'ETD',
        eta: 'ETA'
      },
      aiAssistant: {
        langCode: 'en_US',
        name: 'AI Rate Assistant',
        description: 'Analyzing rate details for you',
        skillPrefix: 'Rate Analysis',
        displayText: 'Analyzing rates based on current filters...',
        analyzeSingle: 'Analyze this {carrier} rate from {pol} to {pod} and provide selection suggestions.',
        analyzeAll: 'Analyze {count} searched E-commerce rates.'
      },
      ranking: {
        title: 'Rate Ranking',
        back: 'Back',
        hotRoutes: 'Hot Routes',
        hotCarriers: 'Hot Carriers',
        freightIndex: 'Freight Index',
        routeTrend: 'Route Trend',
        up: 'Up',
        down: 'Down',
        stable: 'Stable',
        day: 'Day',
        week: 'Week',
        etdPlaceholder: ['Start ETD', 'End ETD'],
        top10Routes: 'TOP 10 Routes',
        top10Carriers: 'TOP 10 Carriers',
        expand: 'Expand',
        collapse: 'Collapse',
        compare: 'Compare',
        multiCompare: 'Multi Compare',
        multiCompareTitle: 'Multi Compare ({count}/6)',
        clear: 'Clear',
        maxCompareWarning: 'Max 6 charts allowed',
        addedToCompare: 'Added to compare bar',
        chartLabels: {
          frequency: 'Query Frequency (%)',
          avgPrice: 'Avg Price ($)'
        },
        routeLines: {
          asia: 'Asia',
          africa: 'Africa',
          americaCanada: 'US/Canada',
          europeMed: 'Europe/Med',
          latinAmerica: 'Latin America',
          ausNz: 'AUS/NZ'
        },
        originPorts: {
          shanghai: 'Shanghai (CNSHA)',
          ningbo: 'Ningbo (CNNGB)',
          shenzhen: 'Shenzhen (CNSZX)'
        },
        queryCount: 'Query Count',
        avgHeat: 'Avg Heat',
        avgPrice: 'Avg Price',
        baseWoWRate: 'Base WoW',
        totalWoWRate: 'Total WoW',
        routeTrendShort: 'Trend',
        daily: 'Daily',
        weekly: 'Weekly',
        close: 'Close',
        addToCompare: 'Add to Compare'
      },
      detailModal: {
        boxPrices: 'Box Rates',
        costDetail: 'Cost Details',
        refundFees: 'Cancellation Fees',
        dnd: 'DND',
        priceTrend: 'Price Trend',
        priceTrendTip: 'Rate trend by ETD for the same lane, carrier and container type',
        totalEstimate: 'Est. Total',
        includes: 'Includes {categories}',
        tips1: 'Fees subject to carrier policy changes.',
        tips2: 'DND period based on actual carrier rules.',
        hint: 'Hint',
        totalLogicHint: 'Total: Sea Freight + POR Fees in main currency + Prepaid FND Fees in main currency.',
        weightHint: 'Default weight: 12,000 KG',
        feeName: 'Fee Name',
        currency: 'Cur',
        amount: 'Amt',
        base: 'Base',
        total: 'Total',
        validityPeriod: 'Validity',
        costPerDay: 'Per Day',
        oceanBase: 'Base Freight',
        oceanFreight: 'Ocean Freight',
        oceanExtra: 'Surcharges',
        free: 'Free',
        categories: {
          OCEAN_BASE: 'Base Freight',
          OCEAN_EXTRA: 'Surcharges',
          POR: 'POR Surcharges',
          FND: 'FND Surcharges',
          OTHERS: 'Others',
          Freight: 'Freight',
          Origin: 'POR Fee',
          Destination: 'FND Fee',
          Others: 'Others'
        },
        labels: {
          vessel: 'Vessel',
          voyage: 'Voyage',
          lane: 'Lane',
          base: 'Base',
          total: 'Total',
          others: 'Others',
          arrival: 'Arrival',
          departure: 'Departure',
          day: 'Day'
        },
        paymentTypes: {
          prepaid: 'Prepaid',
          collect: 'Collect'
        },
        units: {
          perBox: 'Per Container'
        }
      },
      charts: {
        performanceTitle: 'Carrier Performance Analysis',
        positionTitle: 'Market Distribution Analysis',
        currentItem: 'Current Item',
        valueHigh: 'High Value',
        regularRecommend: 'Regular',
        boundaryLine: 'Boundary Line',
        boundaryTip: 'Note: Dotted line is boundary. Points bottom-left mean lower price for same transit or shorter transit for same price.',
        average: 'Avg',
        median: 'P50',
        stdDev: 'Std Dev',
        marketDist: 'Distribution',
        percentile: 'Percentile',
        max: 'Max',
        min: 'Min',
        countUnit: 'pcs'
      },
      status: {
        available: 'Available',
        full: 'Sold Out',
        within15Minutes: '15m ago',
        hoursAgo: '{hours}h ago',
        history: 'History'
      },
      cargoTypes: {
        general: 'General'
      },

      // Price Watch (监控任务)
      priceWatch: {
        // Common labels
        common: {
          active: 'Active',
          paused: 'Paused',
          triggered: 'Triggered',
          expired: 'Expired',
          normal: 'Normal',
          edit: 'Edit',
          delete: 'Delete',
          cancel: 'Cancel',
          confirm: 'Confirm',
          save: 'Save',
          create: 'Create',
          reset: 'Reset',
          search: 'Search',
          refresh: 'Refresh',
          actions: 'Actions',
          status: 'Status',
          remark: 'Remark',
          remarkPlaceholder: 'Enter remark (optional)',
          yes: 'Yes',
          no: 'No',
          all: 'All',
          hide: 'Hide',
          view: 'View',
          noData: '-',
          days: 'Days',
          hours: 'Hours',
          minutes: 'Minutes',
          perDay: 'per day',
          fullDay: 'All day',
          // Watch modes
          watchModes: {
            active: 'Active',
            passive: 'Passive',
            both: 'Both Active & Passive',
            activeDesc: 'System automatically queries rates at set frequency',
            passiveDesc: 'Reuses platform query results for trigger judgment',
            bothDesc: 'Supports both triggers, same result only pushes once'
          },
          // Trigger modes
          triggerModes: {
            priceAny: 'Push on Any Price',
            priceAnyDesc: 'No reference price needed, pushes notification on any rate change',
            targetPrice: 'Push on Target Price',
            targetPriceDesc: 'Set target price, triggers when actual price is above or below target'
          },
          // Frequency options
          frequency: {
            '1h': 'Every 1 hour',
            '2h': 'Every 2 hours',
            '4h': 'Every 4 hours',
            '6h': 'Every 6 hours',
            '12h': 'Every 12 hours',
            '24h': 'Once a day',
            custom: 'Custom',
            customInterval: 'Custom interval (hours)',
            hoursUnit: 'hours',
            estimatedDaily: 'Estimated daily executions'
          },
          // Comparison directions
          directions: {
            below: 'Below target price',
            above: 'Above target price',
            both: 'Above or below target price'
          },
          // Push strategies
          pushStrategies: {
            trackPrice: 'Track Price',
            conditionTrigger: 'Condition Trigger'
          },
          // Notify channels
          notifyChannels: {
            email: 'Email Notification',
            wechat: 'WeChat Service Account',
            workchat: 'WoBao Notification',
            emailConfig: 'Email Notification Config',
            emailPlaceholder: 'Enter email address, separate multiple with commas',
            emailTemplate: 'Email Template',
            emailTemplateDefault: 'Default Template',
            emailTemplateSimple: 'Simple Template',
            emailTemplateDetailed: 'Detailed Template (with trend chart)',
            subscribeWechat: 'Subscribe to receive rate alerts',
            scanWechatQr: 'Scan QR code to follow CargoWareX service account',
            wechatTips: 'After following, system will push rate changes, target price hits, task alerts via the service account.',
            followed: 'Followed',
            skipNow: 'Skip for now',
            alreadyFollowed: 'Already Followed',
            workchatConfigured: 'Work Chat configured',
            workchatDesc: 'Push to internal groups (WeCom, DingTalk, Feishu)',
            workchatNotConfigured: 'Work Chat not configured',
            workchatSetup: 'This feature requires contacting customer service to configure Work Chat.',
            configuredGroups: 'Configured groups:',
            notifyDesc: 'When price meets trigger conditions, system sends alerts via selected channels.'
          },
          // Status options
          taskStatus: {
            active: 'Active',
            paused: 'Paused',
            triggered: 'Triggered',
            expired: 'Expired'
          },
          // Price comparison
          priceComparison: {
            title: 'Price Comparison by Container Type',
            containerType: 'Container Type',
            targetPrice: 'Target Price (USD)',
            currentPrice: 'Current Price (USD)',
            deviation: 'Deviation',
            status: 'Status',
            triggered: 'Triggered'
          },
          // Trigger records
          triggerRecords: {
            title: 'Trigger Records',
            triggerTime: 'Trigger Time',
            priceAtTrigger: 'Price at Trigger',
            condition: 'Condition',
            notifyStatus: 'Notification Status',
            notified: 'Notified',
            notifyFailed: 'Notify Failed'
          }
        },

        // Account management (监控账号)
        account: {
          modal: {
            create: 'Create Monitor Account',
            edit: 'Edit Monitor Account',
            errorUsage: 'Please select at least one usage'
          },
          columns: {
            name: 'Account Name',
            carrierCode: 'Carrier',
            platformType: 'Platform Type',
            usage: 'Account Usage',
            loginAccount: 'Login Account',
            loginPassword: 'Login Password',
            remark: 'Remark'
          },
          messages: {
            createSuccess: 'Monitor account created',
            updateSuccess: 'Monitor account updated',
            createFailed: 'Create monitor account failed',
            updateFailed: 'Update monitor account failed',
            nameRequired: 'Please enter account name',
            carrierRequired: 'Please select carrier',
            platformRequired: 'Please select platform type',
            loginRequired: 'Please enter login account',
            passwordRequired: 'Please enter login password',
            passwordPlaceholder: 'Please enter password',
            passwordEditPlaceholder: 'Leave blank to keep current password',
            namePlaceholder: 'e.g., Maersk Query Main Account',
            carrierPlaceholder: 'Select carrier',
            loginPlaceholder: 'Enter username/email',
            remarkPlaceholder: 'e.g., This account has 50 queries per day limit',
            platformType1: 'Carrier Official Website',
            platformType2: 'Third-party Platform',
            platformType3: 'Internal API',
            usageQuery: 'Query',
            usageWatch: 'Monitor',
            usageBooking: 'Booking',
            deleteConfirm: 'Are you sure to delete this account?',
            deleteSuccess: 'Account deleted',
            toggleEnabled: '{name} {status}',
            enabled: 'Enabled',
            disabled: 'Disabled'
          }
        },

        // CreateWatchTask
        create: {
          // Section titles
          sections: {
            monitorConditions: 'Monitor Conditions',
            monitorSettings: 'Monitor Settings',
            pushSettings: 'Push Settings',
            notificationSettings: 'Notification Settings'
          },
          // Form labels
          labels: {
            taskName: 'Task Name',
            taskNamePlaceholder: 'Enter a task name, or leave blank to generate from the route',
            carrier: 'Carrier (Multi-select)',
            carrierShort: 'Carrier',
            pol: 'POL (Multi-select)',
            polShort: 'POL',
            pod: 'POD (Multi-select)',
            podShort: 'POD',
            containerType: 'Container Type',
            containerTypeMulti: 'Container Type (Multi-select)',
            containerTypePlaceholder: 'Select container type, supports multi-select',
            monitoringDateRange: 'Monitoring Date Range',
            startDate: 'Start Date',
            endDate: 'End Date',
            watchMode: 'Watch Mode',
            watchModeTooltip: 'System supports active and passive monitoring. Active monitoring queries rates at set frequency; passive monitoring reuses platform query results. Enabling both triggers on the earlier condition. Passive monitoring requires no frequency configuration but depends on platform user queries.',
            activeConfig: 'Active Monitoring Config',
            executionAccount: 'Monitor Account',
            executionAccountPlaceholder: 'Select execution account',
            accountConfig: 'Account Config',
            frequency: 'Monitoring Frequency',
            dailyStartTime: 'Daily Start Time (Beijing Time)',
            dailyStartTimePlaceholder: 'Select start time',
            dailyEndTime: 'Daily End Time (Beijing Time)',
            dailyEndTimePlaceholder: 'Select end time',
            estimatedDaily: 'Estimated Daily Executions',
            dedupEnabled: 'Skip duplicate prices',
            dedupDesc: 'Same route, carrier, container type with no price change will not repeat.',
            workdayOnly: 'Workdays only',
            workdayOnlyDesc: 'No notifications on non-workdays.',
            triggerConfig: 'Price Trigger Conditions',
            triggerMode: 'Trigger Mode',
            targetPrice: 'Target Price',
            targetPricePlaceholder: 'Enter target price',
            comparisonDirection: 'Comparison Direction',
            threshold: 'Threshold',
            thresholdPlaceholder: 'Trigger threshold',
            strategyDesc: 'Strategy Description',
            strategyAnyDesc: 'Pushes when any available rate exists, no price threshold.',
            // Multi-container target price
            multiTargetTitle: 'Target Price Settings',
            uniformSet: 'Set Uniformly',
            batchAdjust: 'Batch Adjust',
            batchPercentDown: 'Batch Decrease (%)',
            batchFixedDown: 'Batch Decrease (Fixed Amt)',
            batchPercentUp: 'Batch Increase (%)',
            batchFixedUp: 'Batch Increase (Fixed Amt)',
            multiTargetHint: 'Carrier, POL, POD auto-combined by conditions. Each container type has independent target price, direction, and threshold.',
            // Trigger condition display
            triggerCondition: 'Trigger Condition:',
            anyPriceCondition: 'Push notification when available rate is detected for this route, carrier, and container type. No price threshold.',
            multiContainerCondition: 'Each container type compares independently — triggers when actual price meets conditions set above.',
            singleContainerCondition: 'Actual price {direction} target price ${targetPrice} USD, exceeding ${threshold} USD triggers notification.',
            historyPriceRef: 'Price Reference',
            showHistory: 'View Price History',
            hideHistory: 'Hide Price History',
            historyTip: 'If historical prices exist, shows current week and same week last year records. Otherwise, auto-queries current rates as reference.',
            priceTrendChart: 'Price Trend Chart',
            routeLabel: 'Route:',
            chartHint: 'Hover for values · Solid line = current year · Dashed line = same period last year',
            noHistoryData: 'No historical prices, auto-queried current rates as reference',
            referencePrice: 'Recommended price for reference only, adjust based on actual customer quote strategy.',
            // Email config
            emailSection: 'Email Notification Config',
            emailLabel: 'Email Address',
            emailTemplateLabel: 'Email Template',
            // Remark
            remark: 'Remark',
            remarkPlaceholder: 'Enter remark (optional)',
            // Footer buttons
            btnCancel: 'Cancel',
            btnCreate: 'Create Watch Task',
            btnSave: 'Save Changes',
            btnConfirmFollow: 'Already Followed',
            btnSkipFollow: 'Skip'
          },
          // Messages
          messages: {
            accountLoadFailed: 'Account load failed',
            followSuccess: 'Service account followed, can receive notifications',
            followRemoved: 'Service account removed',
            selectPolPodFirst: 'Please select at least one POL and POD first',
            selectContainerTypeFirst: 'Please select at least one container type first',
            overwriteConfirm: 'Confirm Overwrite',
            overwriteContent: 'Manual price exists. Re-query and overwrite?',
            overwriteOk: 'Confirm Overwrite',
            overwriteCancel: 'Cancel',
            noRecommendPrice: 'No recommended price, please query current price first',
            priceSetSuccess: 'Set {label} ${price} USD',
            applyRecommendSuccess: 'Applied {containerType} recommendation, base: ${basePrice}, target: ${targetPrice}',
            selectPol: 'Please select POL',
            selectPod: 'Please select POD',
            selectCarrier: 'Please select carrier',
            selectPolPodCarrier: 'Please select at least one POL, one POD and one carrier',
            selectContainerType: 'Please select at least one container type',
            fillTargetPrices: 'Please set target prices for: {items}',
            fillThresholds: 'Please set thresholds for: {items}',
            selectAccount: 'Please select execution account',
            validFrequency: 'Please enter valid custom frequency',
            selectNotifyChannel: 'Please select at least one notification channel',
            enterEmail: 'Please enter email address',
            serviceAccountWarning: 'Service account not followed. Will prioritize other channels.',
            priceQuerySuccess: 'Price query successful, recommendation generated',
            uniformTargetTitle: 'Set Uniform Target Price',
            uniformTargetContent: 'Enter uniform target price (USD) to apply to all selected container types:',
            uniformTargetSuccess: 'All combinations set to ${price} USD',
            invalidTargetPrice: 'Please enter a valid target price',
            batchAdjustTitle: 'Batch adjust value',
            batchPercentDownHint: '% (e.g., 5 means decrease by 5%)',
            batchFixedDownHint: 'USD (e.g., 100 means decrease by $100)',
            batchPercentUpHint: '% (e.g., 5 means increase by 5%)',
            batchFixedUpHint: 'USD (e.g., 100 means increase by $100)',
            batchAdjustSuccess: 'Batch adjusted all combination target prices',
            selectPolPodQuery: 'Please select at least one POL and POD before querying price',
            selectCtQuery: 'Please select at least one container type before querying price',
            queryPriceSuccess: 'Price query successful',
            createSuccess: 'Watch task created successfully',
            updateSuccess: 'Watch task updated successfully',
            createFailed: 'Create failed, please retry',
            updateFailed: 'Update failed, please retry',
            prefillSuccess: 'Auto-filled from e-commerce rate query conditions'
          }
        },

        // ImportWatchTask
        import: {
          alert: 'Batch import watch tasks, supports creating multiple monitors at once. Please download the template first, fill in according to the format, then upload.',
          downloadSection: {
            title: 'Download Import Template',
            desc: 'Template includes required field descriptions and sample data',
            button: 'Download Template'
          },
          uploadSection: {
            button: 'Upload Excel File',
            hint: 'Supports .xlsx, .xls format, max 100 records per import',
            singleFileLimit: 'Only one file can be uploaded at a time'
          },
          parsing: {
            tip: 'Parsing Excel file...'
          },
          result: {
            title: 'Import Result',
            total: 'Total {count}',
            success: 'Success {count}',
            failed: 'Failed {count}',
            successTab: 'Success ({count})',
            failedTab: 'Failed ({count})',
            createConfirm: 'Confirm Create {count} Watch Tasks'
          },
          table: {
            rowNumber: 'Row No.',
            pol: 'POL',
            pod: 'POD',
            carrier: 'Carrier',
            containerType: 'Container Type',
            watchMode: 'Watch Mode',
            pushStrategy: 'Push Strategy',
            basePrice: 'Base Price',
            failReason: 'Fail Reason',
            suggestion: 'Suggestion',
            trackPrice: 'Track Price',
            conditionTrigger: 'Condition Trigger'
          },
          messages: {
            downloadSuccess: 'Template downloaded successfully!',
            parseSuccess: 'File parsed successfully',
            parseSuccessMock: 'File parsed successfully (Mock)',
            createSuccess: 'Successfully created {count} watch tasks',
            createFailed: 'Create failed, please retry later'
          },
          // Fix suggestions for errors
          fixSuggestions: {
            invalidPol: 'Check port code format, e.g., CNSHA',
            invalidPod: 'Check port code format, e.g., USLAX',
            invalidCarrier: 'Use standard carrier code, e.g., MSK, COSCO',
            invalidContainerType: 'Supported types: 20GP, 40GP, 40HC, 45HC',
            invalidBasePrice: 'Enter a number, e.g., 2850',
            missingFields: 'Check POL, POD, carrier, and container type are filled'
          },
          errors: {
            invalidPol: 'Invalid POL code',
            invalidPod: 'Invalid POD code',
            invalidCarrier: 'Invalid carrier code',
            invalidContainerType: 'Invalid container type',
            invalidBasePrice: 'Invalid base price format',
            missingFields: 'Missing required fields',
            polRequired: 'POL is required',
            polNotFound: 'POL code {pol} does not exist in system',
            podRequired: 'POD is required',
            podNotFound: 'POD code {pod} does not exist in system',
            carrierNotFound: 'Carrier code/name {carrier} does not exist in system',
            containerTypeRequired: 'Container type is required',
            containerTypeNotSupported: 'Container type {type} is not supported or enabled',
            targetPricePositive: 'Target price must be positive',
            targetPriceInvalid: 'Invalid target price format',
            watchModeRequired: 'Watch mode is required',
            watchModeInvalid: 'Unknown watch mode: {mode}',
            activeFrequencyRequired: 'Monitor frequency is required under Active mode',
            activeFrequencyInvalid: 'Invalid frequency format (e.g., 1h, 2h, 4h, 6h, daily)',
            watchTimeRangeInvalid: 'Daily time range must be in HH:mm-HH:mm format',
            notifyEmailRequired: 'Email is required when email channel is selected',
            notifyEmailInvalid: 'Contains invalid email format: {emails}',
            fixSuggestion: 'Please modify the corresponding row in Excel based on the errors and re-upload.'
          },
          // ImportWatchModal
          modal: {
            steps: {
              templateAndImport: 'Template & Import',
              confirmImport: 'Confirm Import'
            },
            templateSection: {
              title: 'Template & Import',
              downloadBtn: 'Download Batch Monitor Template',
              desc1: 'Download the standard template to batch import data. The system will automatically parse and create monitor tasks.',
              desc2: 'Supports uploading files that meet field requirements. After successful parsing, proceed to confirm import.',
              uploadHint: 'Click or drag file here to upload',
              uploadFormat: 'Supports .xlsx, .xls format, max file size 10MB',
              parsing: 'Parsing...',
              parseSuccess: 'Parsed successfully, {count} records identified',
              retryParse: 'Retry Parse',
              reupload: 'Re-upload',
              downloadStandardTemplate: 'Download Standard Template',
              parseBtn: 'Parse'
            },
            templateFields: {
              title: 'Template Field Description',
              fieldName: 'Field Name',
              required: 'Required',
              desc: 'Description',
              example: 'Example',
              requiredYes: 'Required',
              requiredConditional: 'Conditional',
              requiredNo: 'Optional',
              nextStep: 'Next',
              polDesc: 'Support port code or Chinese name, split by comma',
              podDesc: 'Support port code or Chinese name, split by comma',
              carrierDesc: 'Support carrier code or name, split by comma',
              containerTypeDesc: '20GP / 40GP / 40HC / 45HC',
              targetPriceDesc: 'Used for target price trigger checks',
              watchModeDesc: 'active / passive / both',
              frequencyDesc: 'Required under active monitoring: 1h / 2h / 4h / 6h / daily',
              watchTimeRangeDesc: 'Limits the execution or notification time period',
              notifyChannelsDesc: 'email / service_account',
              notifyTargetDesc: 'Fill in based on notification channel settings',
              remarkDesc: 'Additional notes or comments',
              polExample: 'CNSHA,CNNGB / Shanghai,Ningbo',
              podExample: 'USLAX,USLGB / Los Angeles,Long Beach',
              carrierExample: 'MSK,MSC / Maersk,MSC',
              containerTypeExample: '40HC',
              targetPriceExample: '2500',
              watchModeExample: 'both',
              frequencyExample: '2h',
              watchTimeRangeExample: '09:00-18:00',
              notifyChannelsExample: 'service_account',
              notifyTargetExample: 'sales@example.com',
              remarkExample: 'Priority customer route'
            },
            result: {
              totalLabel: 'Total',
              successLabel: 'Success',
              failedLabel: 'Failed',
              creatableLabel: 'Creatable',
              failedWarning: 'The system has identified task data from the uploaded file. Successful data can directly create monitor tasks. Failed data will not create tasks. Please modify and re-upload based on failure reasons.',
              tabAll: 'All ({count})',
              tabSuccess: 'Creatable ({count})',
              tabFailed: 'Failed ({count})'
            },
            table: {
              rowNum: 'Row',
              dataPreview: 'Data Preview',
              failReason: 'Fail Reason',
              suggestion: 'Suggestion',
              action: 'Action',
              success: 'Success',
              failed: 'Failed',
              pushStrategyTarget: 'Push by Target Price',
              pushStrategyAny: 'Push when Price Available'
            },
            editForm: {
              pol: 'POL',
              pod: 'POD',
              carrier: 'Carrier',
              containerType: 'Container Type',
              targetPrice: 'Target Price',
              watchMode: 'Watch Mode',
              frequency: 'Frequency',
              watchTimeRange: 'Daily Monitor Period',
              notifyChannels: 'Notify Channels',
              notifyTarget: 'Recipient / Email',
              remark: 'Remark',
              polPlaceholder: 'Port code or name',
              podPlaceholder: 'Port code or name',
              carrierPlaceholder: 'Carrier code',
              containerTypePlaceholder: 'Select type',
              targetPricePlaceholder: 'Target price',
              watchModePlaceholder: 'Select mode',
              frequencyPlaceholder: 'Select frequency',
              watchTimeRangePlaceholder: 'e.g. 09:00-18:00',
              notifyTargetPlaceholder: 'Email or contact',
              remarkPlaceholder: 'Remark',
              email: 'Email',
              serviceAccount: 'Service Account',
              watchModeActive: 'Active',
              watchModePassive: 'Passive',
              watchModeBoth: 'Both',
              edit: 'Edit',
              delete: 'Delete',
              deleteConfirm: 'Delete this record?',
              saveAndRevalidate: 'Save & Re-validate',
              cancel: 'Cancel'
            },
            actions: {
              downloadFailed: 'Download Failed Data',
              summary: 'Will create {creatable} successful tasks. {failed} failed records will not be created.',
              reuploadFile: 'Re-upload File',
              confirmCreate: 'Confirm Create Monitor Tasks'
            },
            messages: {
              selectFileFirst: 'Please select a file first',
              parseApiEmpty: 'Parse API returned empty data',
              parseFailedTitle: 'File Parse Failed',
              parseFailedMsg: 'Error reading file. Please check template and re-upload.',
              reuploadTitle: 'Re-upload File',
              reuploadContent: 'Re-uploading will replace current parse results. Continue?',
              reuploadOk: 'Confirm Re-upload',
              reuploadCancel: 'Cancel',
              validatePass: 'Row {row} validated, moved to creatable tasks',
              validateFail: 'Row {row} validation failed: {error}',
              deleteSuccess: 'Row {row} deleted',
              downloadTemplateSuccess: 'Batch monitor template downloaded. Please fill in and upload.',
              downloadTemplateFailed: 'Download template failed',
              noFailedData: 'No failed data',
              failedDataDownloaded: 'Failed data downloaded',
              createSuccess: 'Batch monitor tasks created successfully!',
              noCreatable: 'No creatable monitor tasks',
              createFailed: 'Failed to save monitor tasks. Please retry.',
              taskNameSuffix: 'Monitor'
            },
            watchModeLabels: {
              active: 'Active',
              passive: 'Passive',
              both: 'Both'
            },
            validation: {
              polEmpty: 'POL is empty',
              polEmptySuggestion: 'Please add POL and re-validate',
              podEmpty: 'POD is empty',
              podEmptySuggestion: 'Please add POD and re-validate',
              invalidContainerType: 'Invalid container type',
              invalidContainerTypeSuggestion: 'Supported types: 20GP/40GP/40HC/45HC',
              invalidWatchMode: 'Invalid watch mode',
              invalidWatchModeSuggestion: 'Please select a valid watch mode',
              activeMissingFrequency: 'Active monitoring requires frequency',
              activeMissingFrequencySuggestion: 'Please fill in 1h / 2h / 4h / 6h / daily and re-validate',
              invalidEmail: 'Invalid email format',
              invalidEmailSuggestion: 'Please correct the email format and re-validate'
            },
            csvHeader: 'Row,POL,POD,Carrier,Container Type,Watch Mode,Fail Reason,Suggestion',
            csvFilename: 'batch_import_failed_data.csv',
            templateFilename: 'batch_monitor_template.xlsx'
          }
        },

        // WatchTaskList
        list: {
          filters: {
            searchPlaceholder: 'Search task name',
            statusPlaceholder: 'Filter by status',
            watchModePlaceholder: 'Filter by watch mode',
            refresh: 'Refresh'
          },
          columns: {
            taskName: 'Task Name',
            pol: 'POL',
            pod: 'Destination Port',
            carrier: 'Carrier',
            containerType: 'Container Type',
            watchMode: 'Watch Mode',
            pushStrategy: 'Push Strategy',
            activeFrequency: 'Monitor Frequency',
            dailyStartTime: 'Monitor Time (Beijing Time)',
            basePrice: 'Base Price',
            targetPrice: 'Target Price',
            latestPrice: 'Latest Price',
            priceChange: 'Price Change',
            notifyChannels: 'Notify Channels',
            source: 'Source',
            status: 'Status',
            lastTriggerTime: 'Last Trigger',
            actions: 'Actions'
          },
          actions: {
            edit: 'Edit',
            pause: 'Pause',
            resume: 'Resume',
            viewResult: 'View Result',
            delete: 'Delete',
            deleteConfirm: 'Are you sure to delete this watch task?',
            pauseConfirm: 'Are you sure you want to pause this watch task?',
            resumeConfirm: 'Are you sure you want to resume this watch task?'
          },
          status: {
            active: 'Active',
            paused: 'Paused',
            triggered: 'Triggered',
            expired: 'Expired',
            activeTag: 'Active',
            pausedTag: 'Paused',
            triggeredTag: 'Triggered',
            expiredTag: 'Expired'
          },
          // Modal
          resultModal: {
            title: 'Watch Result - {taskName}',
            taskName: 'Task Name',
            status: 'Status',
            pol: 'POL',
            pod: 'POD',
            carrier: 'Carrier',
            containerType: 'Container Type',
            basePrice: 'Base Price',
            latestPrice: 'Latest Price'
          },
          // Price change display
          priceUp: '↑{change}%',
          priceDown: '↓{change}%',
          messages: {
            paused: 'Paused',
            resumed: 'Resumed',
            pausedMock: 'Paused (Mock)',
            resumedMock: 'Resumed (Mock)',
            deleteSuccess: 'Deleted successfully',
            deleteFailed: 'Delete failed',
            deleteSuccessMock: 'Deleted successfully (Mock)',
            pauseFailed: 'Pause failed',
            resumeFailed: 'Resume failed'
          },
          // Page header & action buttons
          page: {
            title: 'Price Watch Task List',
            importBtn: 'Batch Import',
            createBtn: 'Create Watch Task'
          },
          // Import result alert
          importAlert: {
            title: 'Batch import completed: {successCount} tasks created',
            titleFailed: ', {failedCount} failed',
            viewImported: 'View Imported Tasks',
            batchEditStart: 'Batch Edit & Start',
            viewFailures: 'View Failures'
          },
          // Imported data alert
          importedData: {
            title: '{count} selected rates imported, can create watch tasks',
            titleNoRates: 'Current rate query conditions imported, can create watch tasks',
            source: 'Source:',
            sourceValue: 'E-commerce Rate Query',
            pol: 'POL:',
            pod: 'POD:',
            carrier: 'Carrier:',
            containerType: 'Container Type:',
            all: 'All',
            selectedRates: 'Selected Rates:',
            count: '{count} items',
            createFromSelected: 'Create from Selected Rates',
            createFromCurrent: 'Create from Current Conditions',
            clearImported: 'Clear Imported Data'
          },
          // Batch operation bar
          batchBar: {
            selected: '{count} selected',
            selectAllPage: 'Select All on Page',
            allSelectedPage: 'All selected on page',
            clearSelection: 'Clear Selection',
            hint: 'Select tasks to batch start, pause, edit or detect',
            batchStart: 'Batch Start',
            startSuccess: 'Successfully started {count} task(s)',
            startFailed: 'Batch start failed',
            batchPause: 'Batch Pause',
            pauseSuccess: 'Successfully paused {count} task(s)',
            pauseFailed: 'Batch pause failed',
            batchEdit: 'Batch Edit',
            editSuccess: 'Successfully edited {count} task(s)',
            editFailed: 'Batch edit failed',
            more: 'More',
            batchDetect: 'Detect Now',
            detectOnlyActive: 'Only ACTIVE tasks with ACTIVE monitoring enabled can be detected. Please reselect.',
            detectSuccess: 'Successfully detected {success} task(s), failed {failed}',
            detectFailed: 'Batch detect failed',
            batchDelete: 'Batch Delete',
            deleteSuccess: 'Successfully deleted {count} task(s)',
            deleteFailed: 'Batch delete failed',
            batchExport: 'Export Tasks',
            exportFailed: 'Export tasks failed'
          },
          // Batch operation modals
          batchModals: {
            startTitle: 'Batch Start Watch Tasks',
            startAnalysis: 'Analysis of {count} selected task(s):',
            startable: 'Startable',
            startableDesc: '{count} task(s) — currently PAUSED, can start now',
            startConfirm: 'Only {count} startable task(s) will be started, others skipped.',
            pauseTitle: 'Batch Pause Watch Tasks',
            pauseTotal: '{count} task(s) selected.',
            willPause: 'Will Pause',
            willPauseDesc: '{count} task(s) — currently ACTIVE',
            skip: 'Skip',
            skipDesc: '{count} task(s) — already PAUSED or EXPIRED, no action needed',
            pauseConfirm: 'Tasks will stop monitoring. History preserved. Confirm pausing {count} tasks?',
            deleteTitle: 'Batch Delete Watch Tasks',
            deleteConfirm: 'Confirm deleting {count} selected watch tasks? This operation cannot be undone.',
            deleteAfter: 'After deletion:',
            deletePermanent: 'Watch tasks will be permanently removed and cannot be recovered',
            deleteHistory: 'Historical monitoring records will be retained',
            deleteNotify: 'Configured notifications will stop',
            detectTitle: 'Batch Detect Now',
            detectTotal: 'Will immediately execute price detection for {count} selected tasks.',
            detectDesc: 'Detection does not change existing monitoring frequency. Only adds a manual detection record. Latest price and price change will be updated.',
            // Batch edit drawer
            editTitle: 'Batch Edit Watch Tasks',
            editAlert: 'Only checked fields will be modified. Unchecked fields keep original values. Affects {count} tasks.',
            editFrequency: 'Monitor Frequency',
            editTimeRange: 'Monitor Time Range',
            editStartTime: 'Start Time',
            editEndTime: 'End Time',
            editWatchMode: 'Watch Mode',
            editNotifyChannels: 'Notify Channels',
            editRecipient: 'Notify Recipient',
            editRecipientPlaceholder: 'Enter recipient email or account',
            editTriggerStrategy: 'Trigger Strategy',
            editTargetRule: 'Target Price Rule',
            editUnifiedTarget: 'Unified Target Price',
            editUnifiedTargetPlaceholder: 'Enter unified target price',
            editPercentOff: 'Decrease Percentage',
            editPercentOffPlaceholder: 'e.g., 5',
            editFixedDown: 'Decrease Fixed Amount',
            editFixedDownPlaceholder: 'Enter decrease amount',
            previewTitle: 'Preview Changes',
            previewDesc: 'Will affect {count} tasks, modifying:',
            noChanges: 'No fields checked, no changes will be made.',
            btnPreview: 'Preview Impact',
            btnSave: 'Confirm Save',
            btnCancel: 'Cancel',
            // Target rules
            targetRules: {
              keep: 'Keep Unchanged',
              unified: 'Set Uniformly',
              percentOff: 'Decrease % from Base',
              fixedDown: 'Decrease Fixed from Current'
            },
            // Trigger strategies
            triggerStrategies: {
              conditionTrigger: 'Condition Trigger',
              trackPrice: 'Track Price',
              priceChange: 'Price Fluctuation'
            },
            // Watch modes (batch edit)
            watchModes: {
              active: 'Active Monitoring',
              passive: 'Passive Tracking',
              both: 'Both'
            },
            // Notify channels (batch edit)
            notifyChannelLabels: {
              email: 'Email',
              wechat: 'WeCom',
              wobot: 'WoBot',
              service_account: 'Service Account'
            }
          },
          // Result drawer
          resultDrawer: {
            title: 'Monitor Result - {taskName}',
            basicInfo: 'Task Basic Info',
            taskName: 'Task Name',
            taskNo: 'Task No.',
            status: 'Status',
            pol: 'POL',
            pod: 'POD',
            carrier: 'Carrier',
            containerType: 'Container Type',
            watchMode: 'Watch Mode',
            pushStrategy: 'Push Strategy',
            execAccount: 'Exec Account',
            notifyChannels: 'Notify Channels',
            email: 'Email',
            wechat: 'WeCom',
            wobot: 'WoBot',
            createTime: 'Create Time',
            priceInfo: 'Price Info',
            basePrice: 'Base Price',
            latestPrice: 'Latest Price',
            priceChange: 'Price Change',
            changeAmount: 'Change Magnitude',
            noResult: 'No monitoring results yet, please wait for next query',
            lastTriggerTime: 'Last Trigger Time',
            compareConditions: 'Comparison Conditions & Latest Status',
            noCompareData: 'No comparison data collected yet. Please wait or click "Detect" in the list to trigger crawling manually.',
            triggered: 'Notification Triggered',
            notTriggered: 'Not Triggered',
            currentPrice: 'Current Price',
            targetPrice: 'Target Price',
            compareDirection: 'Direction',
            threshold: 'Threshold',
            priceDiff: 'Price Diff',
            tabLogs: 'Execution Logs',
            tabHistory: 'Historical Average Price & Trend',
            logStats: 'Comparison Stats',
            statsCollect: 'Collect',
            statsTrigger: 'Trigger',
            weeklyComparisonTitle: 'Weekly Historical Comparison:',
            weeklyAverage: 'Weekly Average',
            lastYearAverage: 'Last Year Same Period',
            yoyChange: 'YoY Change',
            currentRouteRefPrice: 'Current Route Reference Price Details:',
            noHistoryData: 'No historical average reference price data for this watch task',
            priceTrendChart: 'Price Trend Chart',
            directionBelow: 'Below target price',
            directionAbove: 'Above target price',
            directionBoth: 'Above or below',
            triggerTypeActive: 'Scheduled Active',
            triggerTypePassive: 'Passive Linkage',
            triggerTypeManual: 'Manual Detect',
            executeStatusSuccess: 'Success',
            executeStatusExecuting: 'Executing',
            executeStatusFailed: 'Failed',
            conditionMet: 'Push Condition Met',
            conditionMetDesc: 'Current price {desc}, notification triggered',
            conditionNotMet: 'Price Not Meeting Trigger Condition',
            conditionNotMetDesc: 'Current price does not meet {strategy} push condition',
            thresholdReached: 'has reached the set threshold',
            updated: 'has been updated',
            // Log section
            logSection: 'Recent Monitor Logs',
            logLoading: 'Loading...',
            logTime: 'Execution Time',
            logTriggerType: 'Trigger Type',
            logActive: 'Active',
            logPassive: 'Passive',
            logManual: 'Manual',
            logResult: 'Result',
            logSuccess: 'Success',
            logFailed: 'Failed',
            logExecuting: 'Executing',
            logPriceCount: 'Rates Found',
            logTriggerCount: 'Triggers',
            logError: 'Error'
          },
          // Failure drawer
          failureDrawer: {
            title: 'Import Failure Details',
            total: '{count} records failed to import, details below:',
            rowNum: 'Row No.',
            pol: 'POL',
            pod: 'POD',
            carrier: 'Carrier',
            containerType: 'Container Type',
            watchMode: 'Watch Mode',
            errorMsg: 'Error',
            suggestion: 'Suggestion',
            defaultSuggestion: 'Check data and re-import'
          },
          // Empty state
          empty: 'No watch tasks yet. Create a watch task or batch import to get started.',
          // Filter no match
          filterNoMatch: 'No matching watch tasks under current filters. Please',
          filterClear: 'clear filter conditions',
          filterNoMatchAfter: 'to view all tasks.'
        }
      }
    },

    // FCL Rate Query
    fcl: {
      title: 'FCL Rate Query',
      actions: {
        combinationQuery: 'Combination Query',
        generatePdf: 'Generate Quote',
        viewQuotationRecords: 'View Quotation Records'
      },
      messages: {
        viewDetailFailed: 'View failed: missing ID',
        inquiryRequired: 'Inquiry',
        validFrom: 'until {endDate}',
        validTo: 'from {beginDate}',
        unknown: 'Unknown',
        noData: '-'
      },
      enums: {
        spaceStatus: {
          smooth: 'Smooth',
          normal: 'Normal',
          singleApply: 'Single Apply',
          overbooked: 'Overbooked',
          notAccepting: 'Not Accepting',
          limited: 'Limited',
          suspended: 'Suspended',
          inquiry: 'Inquiry'
        },
        priceTrends: {
          rising: 'Price Rising',
          falling: 'Price Falling',
          stable: 'Price Stable'
        },
        status: {
          draft: 'Draft',
          normal: 'Normal',
          published: 'Published',
          expired: 'Expired',
          invalid: 'Invalid',
          offline: 'Offline',
          disabled: 'Disabled'
        },
        rateTypes: {
          contract: 'Contract',
          spot: 'SPOT E-commerce'
        },
        cargoTypes: {
          general: 'General',
          dangerous: 'Dangerous',
          frozen: 'Frozen',
          special: 'Special',
          steelCoil: 'Steel Coil',
          liquid: 'Liquid',
          chemical: 'Chemical',
          textile: 'Textile'
        },
        transitTypes: {
          direct: 'Direct',
          transit: 'Transit'
        },
        validations: {
          loadingPortSameAsDestination: 'Port of loading and port of destination cannot be the same',
          destinationPortSameAsLoading: 'Port of destination and port of loading cannot be the same'
        },
        // Export rate modal
        exportPriceDetailModal: {
          palletNature: 'Pallet Nature',
          cargoReadyTime: 'Cargo Ready Time',
          client: 'Client',
          inquiryEnterprise: 'Inquiry Enterprise',
          detailAddress: 'Detail Address'
        }
      },
      tableColumns: {
        priceNo: 'Rate No.',
        pol: 'POL',
        pod: 'POD',
        carrierId: 'Carrier',
        status: 'Status'
      },
      detail: {
        fields: {
          voyage: 'Transit Time',
          carrier: 'Carrier',
          contractNo: 'Contract No.',
          nac: 'NAC',
          freeContainerDays: 'Free Container',
          freeStorageDays: 'Free Storage',
          validPeriod: 'Validity',
          overweightRemarks: 'Overweight Remarks',
          receivingInstructions: 'Receiving Instructions',
          remarks: 'Remarks'
        },
        placeholders: {
          inputVoyage: 'Enter transit time (days)',
          selectCarrier: 'Select Carrier',
          selectContractNo: 'Select Contract No.',
          selectNac: 'Select NAC',
          inputFreeContainerDays: 'Enter free container days',
          inputFreeStorageDays: 'Enter free storage days',
          startDate: 'Start Date',
          endDate: 'End Date',
          inputOverweightRemarks: 'Enter overweight remarks',
          inputReceivingInstructions: 'Enter receiving instructions',
          inputRemarks: 'Enter remarks',
          inputShipName: 'Enter vessel name',
          inputVoyageNumber: 'Enter voyage number',
          selectVesselSchedule: 'Select vessel schedule',
          selectPlaceOfDelivery: 'Select place of delivery',
          selectPortOfDischarge: 'Select port of discharge',
          selectLaneId: 'Select lane',
          inputLaneCode: 'Enter lane code',
          priceNoPlaceholder: 'Generated by system, e.g., FCL2506250001',
          priceNoCopyPlaceholder: 'Regenerated after copying, e.g., FCL2506250001'
        },
        // Transit Ports
        transitPorts: {
          first: '1st Transit Port',
          second: '2nd Transit Port',
          third: '3rd Transit Port',
          selectFirst: 'Select 1st transit port',
          selectSecond: 'Select 2nd transit port',
          selectThird: 'Select 3rd transit port'
        },
        messages: {
          selectCarrier: 'Select carrier',
          selectValidPeriod: 'Select validity',
          selectRateType: 'Select rate type',
          selectDeparturePort: 'Select POL',
          selectDischargePort: 'Select POD',
          saveFirst: 'Save data first',
          loadDataFailed: 'Load failed',
          copyDataLoadFailed: 'Copy failed',
          invalidApiResponse: 'Invalid API response',
          invalidCopyApiResponse: 'Invalid Copy API response',
          unknownError: 'Unknown Error',
          missingFeeId: 'Missing Fee ID',
          containerSettingsUpdated: 'Settings updated'
        },
        sections: {
          ddSettings: 'D&D'
        },
        modals: {
          selectContainerTypes: 'Select box types to display:'
        },
        pageTitles: {
          create: 'New FCL Rate',
          edit: 'Edit FCL Rate',
          view: 'Rate Detail'
        },
        rateDetails: {
          nonContainerBilling: 'Non-box-based',
          containerBillingTitle: 'Price per Container',
          feeNamePlaceholder: 'Select fee name',
          autoFill: 'Auto Fill',
          priceInputPlaceholder: 'Enter price'
        },
        weekdays: {
          monday: 'Mon',
          tuesday: 'Tue',
          wednesday: 'Wed',
          thursday: 'Thu',
          friday: 'Fri',
          saturday: 'Sat',
          sunday: 'Sun'
        }
      }
    },

    // LCL Rate Query
    lcl: {
      title: 'LCL Rate Query',
      actions: {
        combinationQuery: 'Combination Query',
        generatePdf: 'Generate Quote',
        viewQuotationRecords: 'View Quotation Records'
      },
      messages: {
        viewDetailFailed: 'View failed: missing ID',
        inquiryRequired: 'Inquiry',
        validFrom: 'until {endDate}',
        validTo: 'from {beginDate}',
        unknown: 'Unknown',
        noData: '-'
      }
    },

    // Pre-port Rate Query
    preport: {
      title: 'Pre-port Rate Query',
      tableConfigName: 'Pre-port Rate Query Table Config',
      actions: {
        combinationQuery: 'Combination Query'
      },
      messages: {
        viewDetailFailed: 'View failed: missing ID',
        inquiryRequired: 'Inquiry',
        validFrom: 'until {endDate}',
        validTo: 'from {beginDate}',
        unknown: 'Unknown',
        noData: '-'
      },
      enums: {
        status: {
          draft: 'Draft',
          published: 'Published',
          invalid: 'Invalid',
          offline: 'Offline',
          disabled: 'Disabled'
        },
        priceTypes: {
          contract: 'Contract',
          spot: 'SPOT E-commerce'
        },
        cargoTypes: {
          general: 'General',
          dangerous: 'Dangerous',
          frozen: 'Frozen',
          special: 'Special'
        },
        // Detail Configuration
        detail: {
          regionSelection: {
            noSelection: 'Please select region info'
          },
          portInfo: {
            etdPlaceholder: 'Select ETD',
            etaPlaceholder: 'Select ETA'
          }
        }
      }
    },

    // Last Mile Rate Query
    lastmile: {
      title: 'Last Mile Rate Query',
      tableConfigName: 'Last Mile Rate Table',
      actions: {
        combinationQuery: 'Combination Query'
      },
      messages: {
        viewDetailFailed: 'View failed: missing ID',
        inquiryRequired: 'Inquiry',
        validFrom: 'until {endDate}',
        validTo: 'from {beginDate}',
        unknown: 'Unknown',
        noData: '-'
      },
      enums: {
        status: {
          draft: 'Draft',
          normal: 'Normal',
          expired: 'Expired',
          offline: 'Offline'
        },
        priceTypes: {
          contract: 'Contract',
          spot: 'SPOT E-commerce'
        },
        addressTypes: {
          warehouse: 'Warehouse',
          port: 'Port',
          city: 'City',
          district: 'District'
        }
      }
    },

    // Custom Table
    customTable: {
      title: 'Header Settings'
    },

    // Combination Query
    combination: {
      title: 'Combination Query',
      description: 'Query multiple combinations of rate solutions',
      header: {
        back: 'Back',
        pageTitle: 'Combination Query',
        portPrice: 'POR Price',
        trunkPrice: 'Trunk Price',
        lastMilePrice: 'LMR Price'
      },
      steps: {
        step1: {
          number: '1',
          title: 'Enter Conditions',
          description: 'Configure query parameters'
        },
        step2: {
          number: '2',
          title: 'Select Solutions',
          description: 'Choose appropriate方案'
        }
      },
      form: {
        basicInfo: {
          title: 'Basic Information',
          countryOrigin: 'Origin Country',
          countryOriginPlaceholder: 'Select origin country',
          cityOrigin: 'Origin City',
          cityOriginPlaceholder: 'Select origin city',
          countryDest: 'Discharge Country',
          countryDestPlaceholder: 'Select discharge country',
          cityDest: 'Discharge City',
          cityDestPlaceholder: 'Select discharge city',
          pol: 'POL',
          polPlaceholder: 'Select POL',
          pod: 'Discharge Port',
          podPlaceholder: 'Select discharge port',
          directType: 'Direct/Transit',
          directTypeOptions: {
            notSpecified: 'Not Specified',
            direct: 'Direct',
            transit: 'Transit'
          },
          route: 'Route',
          routePlaceholder: 'Select Route',
          carrier: 'Carrier',
          carrierPlaceholder: 'Select Carrier',
          originCountry: 'Origin Country',
          originCountryPlaceholder: 'Select Origin Country',
          destinationCountry: 'Destination Country',
          destinationCountryPlaceholder: 'Select Destination Country',
          supplier: 'Supplier',
          supplierPlaceholder: 'Select Supplier',
          onePrice: 'All-in Price',
          serviceType: 'Service Type',
          serviceTypePlaceholder: 'Enter Service Type',
          cargoType: 'Cargo Type',
          cargoTypePlaceholder: 'Select Cargo Type'
        },
        client: 'Client',
        addressInfo: {
          title: 'Address Information',
          pol: 'POL',
          polPlaceholder: 'Select POL',
          pod: 'POD',
          podPlaceholder: 'Select POD',
          pot: 'Transit Port',
          potPlaceholder: 'Select Transit Port',
          departureAirport: 'Departure Airport',
          departureAirportPlaceholder: 'Select Departure Airport',
          arrivalAirport: 'Arrival Airport',
          arrivalAirportPlaceholder: 'Select Arrival Airport',
          transitAirport: 'Transit Airport',
          transitAirportPlaceholder: 'Select Transit Airport'
        },
        containerInfo: {
          title: 'Box Info',
          containerType: 'Box Type',
          containerTypePlaceholder: 'Select box type',
          quantity: 'Qty',
          quantityPlaceholder: 'Enter Qty',
          addContainer: 'Add Box',
          removeContainer: 'Remove'
        },
        timeInfo: {
          title: 'Time Information',
          etd: 'ETD',
          etdPlaceholder: 'Select ETD',
          eta: 'ETA',
          etaPlaceholder: 'Select ETA'
        },
        buttons: {
          search: 'Query',
          reset: 'Reset',
          next: 'Next',
          back: 'Back'
        }
      },
      results: {
        title: 'Results',
        summary: 'Summary',
        summaryItems: {
          route: 'Route',
          pol: 'POL',
          pod: 'POD',
          carrier: 'Carrier',
          cargoType: 'Cargo Type',
          containers: 'Box Info'
        },
        noResults: 'No solutions found for current filters',
        loading: 'Querying...',
        totalCount: '{count} solutions found',
        rateTypes: {
          portPrice: 'POR Price',
          trunkPrice: 'Trunk Price',
          lastMilePrice: 'LMR Price'
        },
        status: {
          loading: 'Loading',
          loaded: 'Loaded',
          error: 'Error'
        }
      },
      messages: {
        searchSuccess: 'Query completed',
        searchFailed: 'Query failed',
        noDataFound: 'No rate data found',
        selectRateType: 'Select at least one rate type',
        fillRequiredFields: 'Please fill required fields',
        invalidFormData: 'Invalid form data',
        trunkRatesLoaded: 'Trunk rates loaded',
        candidateLoadIncomplete: 'Rate candidates could not be fully loaded or changed during the query. Please retry.',
        candidateLimitExceeded: 'A segment has more than {candidateLimit} candidates. Narrow your filters; no partial results are shown.',
        combinationLimitExceeded: 'There are more than {combinationLimit} valid combinations. Narrow your filters; no partial results are shown.',
        portRatesLoaded: 'POR rates loaded',
        lastMileRatesLoaded: 'LMR rates loaded',
        loadTrunkRatesFailed: 'Load trunk rates failed',
        loadPortRatesFailed: 'Load POR rates failed',
        loadLastMileRatesFailed: 'Load LMR rates failed',
        atLeastOneRateType: 'Check at least one price type',
        atLeastOneContainer: 'Add at least one box type',
        selectContainerType: 'Select box type for row {index}',
        inputContainerQuantity: 'Enter quantity for row {index}',
        atLeastOneRate: 'Select at least one rate solution',
        selectClientRequired: 'Please select a client',
        combinationGenerated: 'Combination success, {count} solutions selected'
      },
      address: {
        loadingPoint: {
          title: 'Loading Point',
          addressType: 'Address Type',
          thirdParty: 'Third Party Address',
          warehouse: 'Warehouse',
          countryPostcode: 'Country/Zip',
          country: 'Select Country',
          postalCode: 'Enter Zip Code',
          selectWarehouse: 'Select Warehouse',
          administrative: 'Admin Division',
          province: 'Select Province',
          city: 'Select City',
          district: 'Select District',
          detail: 'Location',
          street: 'Select Street',
          community: 'Select Community',
          detailAddress: 'Detail Address',
          detailAddressPlaceholder: 'Enter detail address'
        },
        delivery: {
          title: 'Last Mile Address',
          addressType: 'Address Type',
          thirdParty: 'Third Party',
          warehouse: 'Warehouse',
          countryPostcode: 'Country/Zip',
          selectCountry: 'Select Country',
          inputPostcode: 'Enter ZipCode',
          stateCityRegion: 'State/City/Reg',
          selectState: 'Select State',
          selectCity: 'Select City',
          selectRegion: 'Select Region',
          detailAddress: 'Detail Address',
          detailAddressPlaceholder: 'Enter detail address',
          warehouseCode: 'Warehouse',
          selectWarehouse: 'Select Warehouse'
        }
      },
      table: {
        trunkRates: 'Trunk Rate Matches',
        portRates: 'POR Rate Matches',
        lastMileRates: 'LMR Rate Matches',
        clickToSelect: 'Click row to select rate',
        containerInfo: 'Box Info',
        close: 'Close',
        copyText: 'Copy Text'
      },
      modal: {
        exportQuotation: 'Export Quote',
        quickQuotation: 'Quick Quote Text',
        quotationDescription: 'Quote text below. Copy and send to client:',
        quotationTitle: 'Combination Quote',
        queryTime: 'Query Time',
        transportType: 'Type',
        containerInfo: 'Box Info',
        pol: 'POL',
        pod: 'POD',
        eta: 'ETA:',
        carrier: 'Carrier',
        trunkRate: 'Trunk Rate',
        portRate: 'POR Rate',
        lastMileRate: 'LMR Rate',
        selected: 'Selected',
        note: 'Note: Based on current query. Final price based on actual rate.',
        contactService: 'Contact support for details',
        selectClient: 'Select Client'
      },
      enums: {
        cargoTypes: {
          fcl: 'FCL',
          lcl: 'LCL',
          air: 'Air'
        },
        containerTypes: {
          '20gp': '20GP',
          '40gp': '40GP',
          '40hc': '40HC'
        },
        spaceStatus: {
          sufficient: 'Sufficient',
          tight: 'Tight',
          unknown: 'Unknown'
        },
        priceTrend: {
          rising: 'Rising',
          falling: 'Falling',
          stable: 'Stable',
          unknown: 'Unknown'
        },
        rateStatus: {
          valid: 'Valid',
          invalid: 'Invalid',
          pending: 'Pending',
          unknown: 'Unknown'
        },
        freightType: {
          contract: 'Contract',
          spot: 'SPOT E-commerce'
        },
        directFlag: {
          direct: 'Direct',
          transit: 'Transit'
        },
        priceMethod: {
          direct: 'Direct',
          branchLine: 'Branch',
          seaRail: 'Sea-Rail'
        },
        branchLine: {
          haiding: 'Haiding',
          zhapu: 'Zhapu',
          huzhou: 'Huzhou',
          yiwu: 'Yiwu'
        },
        deliveryAddressType: {
          thirdParty: 'Third Party',
          warehouse: 'Warehouse',
          unknown: 'Unknown'
        },
        status: {
          draft: 'Draft',
          normal: 'Normal',
          expired: 'Expired',
          offline: 'Offline',
          unknown: 'Unknown'
        }
      },
      actions: {
        next: 'Next',
        back: 'Back',
        search: 'Query',
        reset: 'Reset',
        printQuotation: 'Print Quote',
        generateCombination: 'Generate Solutions',
        exportQuotation: 'Export Quote',
        copyQuotationText: 'Copy Quote Text',
        bookingNow: 'Book Now',
        lastMileRate: 'LMR Rate: {priceNo}',
        viewDetail: 'View Details'
      },
      card: {
        trunkRate: 'Trunk Rate: {priceNo}',
        portRate: 'POR Rate: {priceNo}',
        lastMileRate: 'LMR Rate: {priceNo}',
        viewDetail: 'View Details'
      },
      portBinding: {
        title: 'Port Binding',
        preportRate: 'Pre-port Rate',
        lastmileRate: 'LMR Rate',
        addressFilled: 'Address filled',
        loadingPointDefault: 'Loading point address',
        deliveryDefault: 'Delivery address',
        pol: 'POL',
        pod: 'POD',
        trunkLabel: 'Trunk',
        trunkTransport: 'Trunk Transport',
        notSelected: 'Not selected',
        polEqRule: '← Pre-port.POL = Trunk.POL',
        podEqRule: 'Trunk.POD = LMR.POD →',
        trunkDefaultDesc: 'POL → POD'
      },
      linkedResults: {
        matchLabels: {
          allIn: 'ALL in',
          precise: 'Precise Match',
          free: 'Free Combination'
        },
        title: 'Tri-Segment Rate Combos',
        count: '({count} total)',
        autoMatchDesc: 'All valid combinations are generated by node and rate matching rules. Sort and browse by page.',
        sortLabel: 'Sort: ',
        sortTotalPrice: 'Total Cost',
        sortTransitDays: 'Transit Days',
        sortTrunkPrice: 'Trunk Freight',
        preportTransport: 'Pre-port',
        trunkTransport: 'Trunk',
        lastmileTransport: 'Last Mile',
        trunkLabel: 'Trunk',
        pol: 'POL',
        pod: 'POD',
        noMatch: '⚠️ No Match',
        launchInquiry: 'Inquire',
        transitDays: '{days} days',
        routeSummary: '{duration} | {directType}',
        directOrTransit: 'Direct/Transit',
        preportFreight: 'Pre-port Amount',
        trunkFreight: 'Trunk Amount',
        lastmileFreight: 'Last-mile Amount',
        totalCost: 'Total Cost',
        viewSchedule: 'View Schedule',
        viewDetail: 'View Detail',
        bookNow: 'Book Now',
        noLinkedResults: 'No tri-segment rate combinations found',
        suggestion: 'Suggestions:',
        suggestion1: '1. Check if POL and POD are correct',
        suggestion2: '2. Try different pre-port or delivery address',
        suggestion3: '3. Launch inquiry for custom quote'
      },
      detailModal: {
        title: 'Tri-Segment Rate Detail',
        pathPreport: '① Pre-port',
        pathPol: '② POL',
        pathTrunk: '③ Trunk',
        pathPod: '④ POD',
        pathLastmile: '⑤ Last Mile',
        tabTrunk: 'Trunk Rate',
        tabPreport: 'Pre-port Rate',
        tabLastmile: 'LMR Rate',
        noTrunkRate: 'No trunk rate',
        noPreportRate: 'No pre-port rate',
        noLastmileRate: 'No LMR rate',
        totalFormula: 'Total = Trunk + LMR + Pre-port'
      },
      scheduleModal: {
        title: 'View Schedule',
        carrier: 'Carrier',
        pol: 'POL',
        pod: 'POD',
        validPeriod: 'Validity'
      }
    },

    // Messages
    messages: {
      searchSuccess: 'Query completed',
      tableSettingsApplied: 'Settings applied',
      combinationQueryPending: 'Combination query under development...',
      batchImportPending: 'Batch import under development...',
      exportPending: 'Export under development...',
      noAccessibleTab: 'You do not have access to any rate tabs.',
      clickTabToLoad: 'Click "{tab}" to load',
      lclPending: 'LCL under development...',
      lclFeatures: 'LCL CRUD and batch operations coming soon',
      airPending: 'Air under development...',
      airFeatures: 'Air CRUD and batch operations coming soon',
      loading: 'Loading...',
      loadSuccess: 'Load successful',
      loadFailed: 'Load failed',
      saveSuccess: 'Save successful',
      saveFailed: 'Save failed',
      quoteSaved: 'Quote saved',
      deleteSuccess: 'Delete successful',
      deleteFailed: 'Delete failed',
      operationSuccess: 'Success',
      operationFailed: 'Failed',
      confirmDelete: 'Are you sure to delete this record?',
      confirmEnable: 'Are you sure to enable this record?',
      confirmDisable: 'Are you sure to disable this record?',
      confirmBatchDelete: 'Are you sure to delete {count} records?',
      confirmBatchEnable: 'Are you sure to enable {count} records?',
      confirmBatchDisable: 'Are you sure to disable {count} records?',
      requiredField: 'Required field',
      invalidFormat: 'Invalid format',
      invalidEmail: 'Invalid email',
      invalidPhone: 'Invalid phone',
      invalidDate: 'Invalid date',
      queryInProgress: 'Querying, please wait...',
      queryCompleted: 'Query completed',
      queryNoResults: 'No rate data found',
      rateNotFound: 'Rate information not found',
      queryError: 'Error occurred during query',
      selectRateFirstToQuote: 'Please select rates to quote first',
      selectRateFirstToGeneratePdf: 'Please select rates to generate a quote PDF first',
      priceTrendPending: 'Price trend is under development...',
      combinationQueryStarted: 'Combination query started',
      combinationQueryCompleted: 'Combination query completed',
      combinationQueryFailed: 'Combination query failed',
      selectRateTypes: 'Select rate types to query',
      atLeastOneRateType: 'Select at least one rate type',
      invalidQueryConditions: 'Invalid query conditions',
      missingRequiredFields: 'Missing required fields',
      dataLoading: 'Data loading...',
      dataLoaded: 'Data loaded',
      dataLoadFailed: 'Data load failed',
      pageInfo: 'Page {current}, total {total}',
      pageSizeChanged: '{size} per page',
      sortBy: 'Sort By',
      sortAsc: 'Ascending',
      sortDesc: 'Descending',
      filterApplied: 'Filter applied',
      filterCleared: 'Filter cleared',
      filterReset: 'Filter reset',
      // Added for combination query
      atLeastOneRate: 'Please select at least one rate',
      combinationGenerated: 'Combination success, {count} solutions selected',
      selectTrunkRateFirst: 'Please select trunk rate first',
      selectClientRequired: 'Please select client',
      rateInfoNotFound: 'Selected rate info not found'
    },
    salesQuotation: {
      tabs: {
        fcl: 'FCL',
        lcl: 'LCL',
        air: 'Air'
      },
      quickQuote: {
        title: 'Quick Quote',
        customerLabel: 'Quote Customer (Optional): ',
        customerPlaceholder: 'Search / Select Customer',
        customerModeLabel: 'Quote Customer: ',
        customerModeName: 'Customer Name',
        customerModeLevel: 'Customer Level',
        customerSearchPlaceholder: 'Search and select customer (optional)',
        levelPlaceholder: 'Select customer level',
        levelMarkupTitle: 'Level Markup',
        levelMarkupDesc: 'Match sales markup rules by customer level and apply unit markup',
        levelMarkupEmpty: 'No matching level markup rules',
        smartMarkupRuleLabel: 'Markup Rule',
        manualEditBanner: 'Quote text has been manually modified',
        resetToGenerated: 'Restore Auto-generated',
        oceanMarkupTitle: 'Ocean Freight Markup',
        airMarkupTitle: 'Air Freight Markup',
        onlyForPricedTypes: 'Only applies to container types with prices',
        noMarkupContainerType: 'No container types available',
        lclOnlyForUnitPrice: 'Markup on sell unit price (by charge unit, not container type)',
        lclUnitMarkup: 'Unit Markup',
        lclNoUnitPrice: 'No unit price available',
        lclMinCharge: 'Min. Charge',
        airOnlyForUnitPrice: 'Markup applies to all weight tiers and min charge (M / N / 45+ …)',
        airUnitMarkup: 'Unit Markup',
        airNoUnitPrice: 'No unit price available',
        airMinCharge: 'Min. Charge',
        smartMarkupTitle: 'Smart Markup',
        smartMarkupDesc: 'Match LCL sales markup rules after selecting a customer',
        smartMarkupDescByLevel: 'Match sales markup rules after selecting a customer level',
        smartMarkupDescByLevelAir: 'Match sales rules with air markup enabled (density×weight matrix, N tier)',
        smartMarkupRulePlaceholder: 'Select markup rule',
        btnConfirmCopy: 'Confirm & Copy',
        copiedSuccess: 'Quote text copied to clipboard',
        surchargeTitle: 'Surcharges',
        defaultCheckedLabel: 'Default On',
        defaultSurchargeTooltip: 'Auto-check all surcharges each time the dialog opens',
        surchargeOcean: 'Ocean Surcharge',
        surchargeOrigin: 'Origin Charges',
        surchargeDest: 'Destination Charges',
        surchargeAirTrunk: 'Mainline Surcharge',
        surchargeAirOrigin: 'Origin Charges',
        surchargeAirDest: 'Destination Charges',
        surchargeEmpty: '(No matched surcharge)',
        remarksTitle: 'Remarks',
        defaultRemarksTooltip: 'Auto-check all remarks each time the dialog opens',
        remarkPickup: 'Receiving Instructions',
        remarkFreeDetention: 'Free Detention',
        remarkFreeDemurrage: 'Free Demurrage',
        remarkOverweight: 'Overweight Remarks',
        remarkWeightLimit: 'Weight Limit',
        remarkOther: 'Remarks',
        customMessageTitle: 'Custom Message',
        positionLabel: 'Position: ',
        posTop: 'Top',
        posBottom: 'Bottom',
        customPlaceholder: 'Enter custom message...',
        btnGeneratePdf: 'Generate PDF Quote',
        btnConfirmQuote: 'Confirm Quote (Copy + Save)',
        btnCancel: 'Cancel',
        savedSuccess: 'Quote copied and saved, record no.: {quoteNo}',
        saveFailed: 'Operation failed, please retry',
        textCarrier: 'Carrier',
        textAirline: 'Airline',
        textPol: 'POL',
        textPod: 'POD',
        textAirPol: 'Origin Airport',
        textAirPod: 'Destination Airport',
        textTransitType: 'Transit Type',
        textValidPeriod: 'Validity',
        textOceanFreight: 'Ocean Freight',
        textOceanFreightDetail: 'Ocean Freight Details',
        textBaseFreight: 'Base Ocean Freight',
        textAirFreight: 'Air Freight',
        textSailings: 'Sailings ({count} schedules)',
        textPickupNote: 'Receiving Instructions: {note}',
        textFreeDetentionNote: 'Free Detention: {days} days',
        textFreeDemurrageNote: 'Free Demurrage: {days} days',
        textWeightLimitNote: 'Weight Limit: {weight} KG',
        textOtherRemark: 'Remark: {remark}',
        textSurchargeMin: 'Min {v}',
        textSurchargeMax: 'Max {v}',
        textIncluded: 'Incl.',
        textCountIn: 'Count',
        textPerTicket: '/BL',
        textDirect: 'Direct',
        textTransit: 'Transit',
        airTierM: 'M (Min)',
        airTierN: 'N',
        airTier45: '45+',
        airTier100: '100+',
        airTier300: '300+',
        airTier500: '500+',
        airTier700: '700+',
        airTier1000: '1000+',
        airTier2000: '2000+'
      },
      wobaoQuotation: {
        title: 'WoBao Quotation',
        formatTitle: 'Quotation Format',
        linkFormat: 'Link',
        posterFormat: 'Poster',
        posterPending: 'Poster generation is not connected yet',
        previewTitle: 'Live Preview',
        wecomSend: 'Send to WeCom Group',
        wecomPending: 'The digital employee API is not connected yet',
        remarkPickup: 'Pickup Instructions',
        remarkOverweight: 'Overweight',
        remarkFreeDetention: 'Free Detention',
        remarkOther: 'Other Remarks',
        hardcodedPickup: '■ Pickup Instructions: Please contact us in advance to confirm pickup time and location. Notify us early for overweight/oversized cargo.',
        hardcodedOverweight: '■ Overweight: Single pieces over 2 tons or 3 meters incur overweight/overlength surcharges; final amount is based on actual measurement.',
        hardcodedFreeDetention: '■ Free Detention: Destination free time follows carrier policy; charges beyond free time are borne by the consignee.',
        hardcodedOther: '■ Other Remarks: This quote excludes cargo insurance; customers are advised to purchase separately. Rates are subject to confirmation at booking.',
        customMessageTitle: 'Custom Message',
        messageTitle: 'Message',
        posTop: 'Top',
        posBottom: 'Bottom',
        customMessagePlaceholder: 'Message to customer (optional)',
        customerNameMode: 'Customer Name',
        customerLevelMode: 'Customer Tier',
        customerLevelPlaceholder: 'Select customer tier',
        baseOceanFreight: 'Base Ocean Freight',
        baseFreight: 'Base Freight',
        prepaid: 'Prepaid',
        collect: 'Collect',
        payMethod: 'Payment',
        orig: 'Cost',
        quoted: 'Quote',
        perTicket: 'Per B/L',
        quickMarkupTitle: 'Quick Markup',
        quickMarkupDesc: 'Applies only to container types with prices',
        quickMarkupDescLcl: 'Base ocean freight marks up by unit price; surcharges by per B/L',
        quickMarkupBtn: 'Quick Markup',
        markupConfigTitle: 'Quick Markup Config',
        markupConfigHintTitle: 'About',
        markupConfigHint: 'Markup is applied on top of the base fee',
        oceanFreightMarkup: 'Ocean Freight Markup',
        unitPriceMarkup: 'Unit Price',
        oceanSurchargeMarkup: 'Ocean Surcharge Markup',
        originSurchargeMarkup: 'POL Charges Markup',
        destSurchargeMarkup: 'POD Charges Markup',
        perTicketMarkup: 'Per B/L Markup',
        resetMarkupConfig: 'Reset Default',
        saveMarkupConfig: 'Save Config',
        resetMarkupSuccess: 'Reset to defaults',
        saveMarkupSuccess: 'Config saved',
        saveMarkupFailed: 'Failed to save config',
        linkEmailSent: 'Quote link has been sent to the customer email',
        emailDialogTitle: 'Send Email',
        emailDialogToLabel: 'Recipient Email',
        emailDialogToExtra: 'Multiple emails supported; separate with commas, semicolons, or new lines',
        emailDialogToPlaceholder: 'Enter recipient email(s), separated by commas / semicolons / new lines',
        emailDialogRequired: 'Please enter recipient email',
        emailDialogInvalid: 'Invalid email address found, please check and retry',
        emailLevelTooltip: 'Please select a customer tier first',
        quickMarkupApplied: 'Markup applied',
        surchargeCategoryOff: 'Enable the surcharge category first',
        customerSelectedBanner: '{n} customer(s) selected; quote amounts adjusted by customer tier',
        customerLevelSelectedBanner: 'Customer tier {level} selected; quote amounts adjusted by tier',
        baseOceanFreightMarkup: 'Base ocean freight markup',
        baseAirFreightMarkup: 'Base air freight markup',
        baseFreightMarkup: 'Base freight markup',
        quoteLinkLabel: 'Quote link: ',
        customerShortLabel: 'Customer: '
      },
      linkDetail: {
        pageTitle: 'Sales Quotation',
        docTitle: 'Quotation',
        dateLabelShort: 'Date',
        routeTitle: 'Route Info',
        routeFallback: 'Route',
        feeItemFallback: 'Fee item',
        previewTokenBlocked: 'This preview link cannot open the quote detail. Please send the email from WoBao Quotation and use the formal link in the email.',
        missingToken: 'Invalid link: access token is missing',
        notFound: 'Quotation not found or no longer available',
        expired: 'Quotation link is invalid or expired'
      },
      generatePdf: {
        title: 'Generate PDF Quote',
        docTitle: 'QUOTATION',
        noLabel: 'No.: ',
        dateLabel: 'Date: ',
        routeInfo: 'Route Info',
        routeInfoPrefix: 'Rate {n} — Route Info',
        recordDivider: 'Rate {n}',
        departurePort: 'POL',
        transitPort: 'Transit Port',
        arrivalPort: 'Port of Discharge',
        placeOfDelivery: 'Place of Receipt',
        deliveryAddress: 'Delivery Address',
        destinationPort: 'POD',
        departureAirport: 'Departure Airport',
        destinationAirport: 'Destination Airport',
        departureStation: 'Departure Station',
        destinationStation: 'Destination Station',
        voyageDays: 'Transit {days} Days',
        voyageHours: 'Transit {hours} Hours',
        validPeriod: 'Validity: ',
        grandTotal: 'Total',
        scheduleSection: 'Schedule',
        vessel: 'Vessel',
        voyage: 'Voyage',
        laneCode: 'Lane Code',
        customsCutoff: 'Customs Cutoff',
        portCutoff: 'Port Cutoff',
        transitDays: 'Transit(days)',
        oceanFreightSection: 'Ocean Freight',
        airFreightSection: 'Air Freight',
        feeName: 'Fee Name',
        unit: 'Unit',
        billingUnit: 'Billing Unit',
        containerTypePageHint: 'Box types {from}-{to} / {total} total',
        quickMarkupTip: 'Per container: 20GP+25/40GP+50/40HC+50; Per bill: +25',
        oceanFreightMarkupTip: '20GP+25 / 40GP+50 / 40HC+50',
        currency: 'Currency',
        origPrice: '{label} Cost',
        quotedPrice: '{label} Quote',
        perTicketOrig: 'BL Cost',
        perTicketMarkup: 'BL Markup',
        perTicketQuoted: 'BL Quote',
        perTicketFee: 'BL Fee',
        specialNote: 'Special Note',
        surchargeIncluded: 'Surcharge (Incl.)',
        surchargeIncludedTip: 'Fee included in total price, no extra charge',
        surchargeExtra: 'Surcharge (Excl.)',
        surchargeExtraTip: 'Fee not included in total price, charged separately',
        remarksSection: 'Remarks',
        remarksPlaceholder: 'Remarks will be auto-filled after checking options, can be edited directly...',
        extraRemarks: 'Additional Clauses: ',
        extraRemarksPlaceholder: 'Enter additional remarks or clauses...',
        customerSection: 'Quote Customer: ',
        addCustomer: 'Add Customer',
        customerPlaceholder: 'Search / Select Customer',
        contactPlaceholder: 'Select Contact',
        emailPlaceholder: 'Email: Auto-filled after selecting contact',
        surchargeLabel: 'Surcharges: ',
        surchargeOcean: 'Ocean Surcharge',
        surchargeOrigin: 'Origin Charges',
        surchargeDest: 'Destination Charges',
        surchargeAirTrunk: 'Mainline Surcharge',
        surchargeAirOrigin: 'Origin Charges',
        surchargeAirDest: 'Destination Charges',
        remarksLabel: 'Remarks: ',
        pickupRemark: 'Receiving Instructions',
        overweightRemark: 'Overweight Remarks',
        freeDetentionRemark: 'Free Detention',
        freeDemurrageRemark: 'Free Demurrage',
        weightLimitRemark: 'Weight Limit',
        otherRemark: 'Remarks',
        authorizedSignature: 'Authorized Signature',
        savedSuccess: 'Quote saved, record no.: {quoteNo}',
        saveFailed: 'Save failed, please retry',
        emailSent: 'Quote sent to: {recipients}, record no.: {quoteNo}',
        downloadSuccess: 'Quote downloaded, record no.: {quoteNo}',
        downloadFailed: 'PDF generation failed, please retry',
        notLoaded: 'Quote content not loaded',
        remarkPickupPrefix: '• Receiving Instructions: {note}',
        remarkFreeDetentionPrefix: '• Free Detention: {days} days',
        remarkFreeDemurragePrefix: '• Free Demurrage: {days} days',
        remarkWeightLimitPrefix: '• Weight Limit: {weight} KG',
        remarkOtherPrefix: '• Remark: {remark}',
        lclCompanyFallback: 'Control Tower Logistics',
        lclCustomerLabel: 'Customer: ',
        lclOrigUnitPrice: 'Orig. Unit Price',
        lclQuotedUnitPrice: 'Quoted Unit Price',
        lclMinCharge: 'Min. Charge',
        lclDownloadPdf: 'Download PDF',
        lclDownloadSuccess: 'Quote downloaded, no.: {quoteNo}',
        airCompanyFallback: 'Control Tower Logistics',
        airCustomerLabel: 'Customer: ',
        airOrigUnitPrice: 'Orig. N Rate',
        airQuotedUnitPrice: 'Quoted N Rate',
        airOrigPrice: 'Orig. Price',
        airQuotedPrice: 'Quoted Price',
        airMinCharge: 'Min. Charge',
        airDownloadPdf: 'Download PDF',
        airDownloadSuccess: 'Quote downloaded, no.: {quoteNo}',
        btnCancel: 'Cancel',
        btnSave: 'Save Record',
        btnEmail: 'Send Email',
        btnDownload: 'Download PDF',
        emailTooltip: 'Please select a contact to get their email address'
      },
      linkView: {
        docTitle: 'Quotation',
        date: 'Date',
        message: 'Message',
        rateN: 'Rate {n}',
        routeInfo: 'Route Info',
        voyageHoursText: 'Transit {hours} Hours',
        voyageDaysText: 'Transit {days} Days',
        validPeriod: 'Validity: ',
        airFreight: 'Air Freight',
        baseFreight: 'Base Freight',
        oceanFreight: 'Ocean Freight',
        prepaid: 'Prepaid',
        densityLevel: 'Density Level',
        currency: 'Currency',
        feeName: 'Fee Name',
        billingUnit: 'Billing Unit',
        origUnitPrice: 'Orig. Unit Price',
        quotedUnitPrice: 'Quoted Unit Price',
        orig: 'Cost',
        quoted: 'Quote',
        feeItem: 'Fee Item',
        perTicket: 'Per B/L',
        total: 'Total',
        direct: 'Direct',
        transit: 'Transit',
        surchargeOcean: 'Ocean Surcharge',
        surchargeOrigin: 'Origin Charges',
        surchargeDest: 'Destination Charges',
        surchargeAirTrunk: 'Mainline Surcharge',
        surchargeAirOrigin: 'Origin Airport Charges',
        surchargeAirDest: 'Destination Airport Charges',
        departureAirport: 'Departure Airport',
        transitAirport: 'Transit Airport',
        destinationAirport: 'Destination Airport',
        departurePort: 'POL',
        transitPort: 'Transit Port',
        destinationPort: 'POD',
        deliveryAddress: 'Delivery Address',
        placeOfDelivery: 'Place of Receipt',
        route: 'Route',
        destAirport: 'Destination Airport',
        destStation: 'Destination Station',
        destSeaport: 'POD',
        originAirport: 'Departure Airport',
        originStation: 'Departure Station',
        originSeaport: 'POL',
        previewLinkHint: 'This preview link cannot open the quote detail. Please send the email from Wobao Quotation and use the formal link in the email.',
        invalidToken: 'Invalid link: missing token',
        notFound: 'Quote not found or unavailable',
        expiredOrInvalid: 'Quote link is invalid or expired'
      },
      pdfDetail: {
        title: 'PDF Quote Detail',
        typeTag: 'PDF Quote',
        quotationNoLabel: 'Quote No.: ',
        typeLabel: 'Type: ',
        createdAtLabel: 'Quote Time: ',
        createdByLabel: 'Quoted By: ',
        surchargeIncludedLabel: 'With Surcharge: ',
        orderTimeLabel: 'Order Time: ',
        markupSnapshot: 'Markup Snapshot: ',
        rateSnapshot: 'Rate Snapshot ({count})',
        recordDivider: 'Rate {n}',
        surchargeDetail: 'Surcharge Detail ({count})',
        surchargeIncludedTip: 'Included in total price ({count})',
        surchargeExtraTip: 'Excluded from total price ({count})',
        remarks: 'Remarks',
        extraClauses: 'Additional Clauses',
        createOrder: 'Place Order Based on This Quote',
        noRateData: 'No rate data in this quote',
        generating: 'Generating PDF for quote {no}...',
        downloaded: 'Quote {no} PDF downloaded',
        emailSent: 'Quote {no} sent{route}',
        orderCreating: 'Creating order based on quote {no}',
        colPriceNo: 'Rate No.',
        colCarrier: 'Carrier',
        colPol: 'POL',
        colPod: 'Port of Discharge',
        colOrigPrice: '{label} Cost',
        colQuotedPrice: '{label} Quote',
        colValidPeriod: 'Validity',
        colFeeName: 'Fee Name',
        colFeeType: 'Fee Type',
        colBilling: 'Billing',
        colOrigTicket: 'BL Cost',
        colQuotedTicket: 'BL Quote',
        chargeTypeOcean: 'Ocean Surcharge',
        chargeTypeOrigin: 'Origin Charges',
        chargeTypeDest: 'Destination Charges',
        chargeTypeOther: 'Surcharge',
        feeConfirmTitle: 'Fee Confirmation',
        feeItem: 'Fee Item',
        feeType: 'Fee Type',
        billingUnit: 'Billing Unit',
        perTicketFee: 'BL Fee',
        seaFreight: 'Ocean Freight',
        btnClose: 'Close',
        btnEmail: 'Send Email',
        btnDownload: 'Download PDF',
        confirmOk: 'Confirm Order',
        confirmCancel: 'Cancel',
        quotationLabel: 'Quote: ',
        markupLabel: 'Markup: ',
        yes: 'Yes',
        no: 'No',
        receivableTag: 'Receivable',
        containerUnit: 'Container',
        ticketUnit: 'BL'
      },
      quickDetail: {
        title: 'Quick Quote Detail',
        typeTag: 'Quick Quote',
        quotationNoLabel: 'Quote No.: ',
        typeLabel: 'Type: ',
        createdAtLabel: 'Quote Time: ',
        surchargeIncludedLabel: 'With Surcharge: ',
        orderTimeLabel: 'Order Time: ',
        markupSnapshot: 'Markup Snapshot: ',
        rateSnapshot: 'Rate Snapshot ({count})',
        recordDivider: 'Rate {n}',
        remarks: 'Remarks',
        extraClauses: 'Additional Clauses',
        quoteText: 'Quote Text: ',
        diffLabel: 'Text Modification Log',
        diffBadge: 'Manually Modified',
        diffBefore: 'Before (Auto-generated)',
        diffAfter: 'After (Final Quote)',
        createOrder: 'Place Order Based on This Quote',
        noRateData: 'No rate data in this quote',
        orderCreating: 'Creating order based on quote {no}',
        feeConfirmTitle: 'Fee Confirmation',
        feeConfirmOkText: 'Confirm Order',
        feeConfirmCancelText: 'Cancel',
        quotationLabel: 'Quote: ',
        markupLabel: 'Markup: ',
        seaFreight: 'Ocean Freight',
        feeItem: 'Fee Item',
        feeType: 'Fee Type',
        billingUnit: 'Billing Unit',
        colRateId: 'Rate ID',
        colPol: 'POL',
        colPod: 'Port of Discharge',
        colOrigPrice: '{label} Cost',
        colQuotedPrice: '{label} Quote',
        colValidPeriod: 'Validity',
        btnClose: 'Close',
        yes: 'Yes',
        no: 'No',
        receivableTag: 'Receivable',
        containerUnit: 'Container',
        markupDetailLabel: '└ Markup Detail: '
      },
      enum: {
        source: {
          internal: 'Internal Inquiry',
          external: 'External Inquiry',
        },
      },
      list: {
        colQuotationNo: 'Quote No.',
        colType: 'Type',
        colSource: 'Source',
        colClient: 'Quote Customer',
        colClientPlaceholder: 'Please Select Quote Customer',
        colRateSummary: 'Rate Summary',
        colMainPrice: 'Main Price',
        colSurcharge: 'Surcharge',
        colCreatedAt: 'Quote Time',
        colCreatedDate: 'Quote Date',
        colCreatedBy: 'Quoted By',
        colStatus: 'Status',
        colRemarks: 'Remarks',
        colAction: 'Actions',
        includeSurcharge: 'With Surcharge',
        excludeSurcharge: 'Excl.',
        orderIndex: 'Order {n}',
        orderEnterprise: 'Client: ',
        orderTime: 'Order Time: ',
        orderCreatedBy: 'Ordered By: ',
        noOrderRecord: 'No order records',
        actionView: 'View',
        actionPlaceOrder: 'Order',
        actionSendEmail: 'Send Email',
        actionDownloadPdf: 'Download PDF',
        rateCount: '{count} rates total',
        sendEmailSuccess: 'Email sent successfully',
        sendEmailFailed: 'Failed to send email'
      },
      rateSelection: {
        title: 'Select Rate to Order',
        tip: 'Quote contains {count} rates, please select one to proceed',
        rateNumber: 'Rate {n}',
        validPeriod: 'Validity: ',
        vesselVoyage: 'Vessel/Voyage: ',
        transitTag: 'Transit',
        payableFees: 'Payable (Cost)',
        receivableFees: 'Receivable (Quote)',
        confirmOrder: 'Confirm Order',
        expired: 'Expired, cannot place order',
        close: 'Close',
        colFeeItem: 'Fee Item',
        colBillingUnit: 'Billing Unit',
        colTicketFee: 'BL Fee',
        seaFreight: 'Ocean Freight',
        containerUnit: 'Container'
      }
    },
    express: {
      fields: {
        loadMode: 'Load Mode',
        queryDate: 'Query Date',
        carrier: 'Express Carrier',
        serviceType: 'Service Type',
        billingModel: 'Billing Model',
        priceNo: 'Rate No.',
        source: 'Source',
        status: 'Status',
        accountNo: 'Account',
        office: 'Office',
        routeType: 'Route Type',
        currency: 'Currency',
        paymentTerm: 'Payment Term',
        country: 'Country',
        province: 'Province/State',
        city: 'City',
        district: 'District/County',
        township: 'Township/Street',
        detailAddress: 'Detailed Address',
        postalCode: 'Postal Code',
        originCountry: 'Origin Country',
        originProvince: 'Origin Province/State',
        originCity: 'Origin City',
        originDistrict: 'Origin District/County',
        originTownship: 'Origin Township/Street',
        originDetailAddress: 'Origin Detailed Address',
        originPostalCode: 'Origin Postal Code',
        originWarehouse: 'Origin Warehouse',
        destCountry: 'Destination Country',
        destProvince: 'Destination Province/State',
        destCity: 'Destination City',
        destDistrict: 'Destination District/County',
        destTownship: 'Destination Township/Street',
        destDetailAddress: 'Destination Detailed Address',
        destPostalCode: 'Destination Postal Code',
        destWarehouse: 'Destination Warehouse',
        onePrice: 'All-in Price',
        cargoType: 'Cargo Type',
        pieces: 'Pieces',
        cargoDimensions: 'Cargo Dimensions (cm)',
        actualWeight: 'Actual Weight (kg)',
        lengthCm: 'Length (cm)',
        widthCm: 'Width (cm)',
        heightCm: 'Height (cm)',
        totalVolume: 'Total Volume (m3)',
        totalWeightTon: 'Total Weight (t)',
        pickupRequired: 'Pickup Required',
        deliveryRequired: 'Delivery Required',
        expectedVehicleType: 'Expected Vehicle',
        pricingPreference: 'FTL Pricing Preference',
        billingWeight: 'Billing Weight',
        volumeWeight: 'Volume Weight',
        validity: 'Validity',
        billingMethod: 'Billing Method',
        volumetricFactor: 'Volumetric Factor',
        minBillingWeight: 'Min Billing Weight',
        pickupFee: 'Pickup Fee',
        deliveryFee: 'Delivery Fee',
        loadingFee: 'Loading Fee',
        vehicleType: 'Vehicle Type',
        vehicleCapacity: 'Vehicle Capacity',
        vehicleVolume: 'Vehicle Volume',
        firstWeight: 'First Weight',
        firstWeightThreshold: 'First Weight Threshold',
        firstWeightPrice: 'First Weight Price',
        additionalWeightUnit: 'Additional Weight Unit',
        additionalWeightPrice: 'Additional Weight Price',
        weightTierAdditionalWeightPrice: 'Additional Weight Unit Price',
        weightTierMinCharge: 'Minimum Charge (Total Price)',
        unitPrice: 'Unit Price',
        unitPriceVolume: 'Volume Unit Price',
        tripPrice: 'Trip Price',
        kmPrice: 'Price per km',
        minKm: 'Min km',
        minCharge: 'Min Charge',
        baseFreight: 'Base Freight',
        chargeableBase: 'Chargeable Base',
        surchargeTotal: 'Surcharge Total',
        totalAmount: 'Total Amount',
        calculationWarnings: 'Calculation Warnings',
        chargeName: 'Fee Name',
        billingMode: 'Billing Mode',
        chargeConfig: 'Rate Config',
        measure: 'Billing Unit',
        calculationProcess: 'Calculation Process',
        quantity: 'Quantity',
        unitRate: 'Unit Rate',
        amount: 'Amount',
        createdBy: 'Created By',
        dateCreated: 'Created At',
        modifiedBy: 'Last Modified By',
        dateModified: 'Last Modified At'
      },
      placeholders: {
        all: 'All',
        queryDate: 'Select query date',
        carrier: 'Select express carrier',
        office: 'Select office',
        serviceType: 'Select service type',
        billingModel: 'Select billing model',
        priceNo: 'Enter rate no.',
        cargoType: 'Select cargo type',
        warehouse: 'Select warehouse',
        expectedVehicleType: 'Enter vehicle type'
      },
      sections: {
        origin: 'Origin',
        destination: 'Destination'
      },
      actions: {
        search: 'Search',
        reset: 'Reset',
        detail: 'Detail',
        close: 'Close',
        associateConsignment: 'Link Consignment',
        cancelAssociation: 'Cancel Link',
        confirmAssociation: 'Confirm Link'
      },
      messages: {
        resultCount: '{count} express rates total',
        noData: 'No express rate results',
        fetchFailed: 'Failed to query express rates',
        detailFetchFailed: 'Failed to load express rate detail',
        noDetail: 'No rate detail',
        exportFilename: 'Express Rate Query'
      },
      sort: {
        default: 'Latest Validity Start',
        priceAsc: 'Price Asc by Currency',
        priceDesc: 'Price Desc by Currency',
        priceTip: 'Prices are compared within each currency. Multi-currency and incomplete rates are listed afterward.'
      },
      labels: {
        recommended: 'Recommended',
        surchargeCount: '{count} surcharges',
        noLimit: 'No Limit',
        tier: 'Tier {index}',
        tierCount: '{count} weight tiers',
        totalPerKm: 'Total / km',
        totalPerTrip: 'Total / trip',
        totalAmount: 'Total Amount',
        expired: 'Expired'
      },
      detail: {
        title: 'Rate Detail',
        basicInfo: 'Basic Information',
        routeInfo: 'Route Information',
        billingRule: 'Billing Rule',
        billingDetail: 'Billing Detail',
        billingFormula: 'Billing Formula',
        calculation: 'Calculation Result',
        surchargeDetail: 'Surcharge Detail',
        operationLog: 'Operation Log',
        feeCalculation: 'Fee Calculation',
        finalAmount: 'Total Amount'
      },
      formula: {
        firstAdditionalBase: 'Base freight = first-weight price + additional-weight fee',
        unitPriceBase: 'Base freight = billing quantity × unit price',
        weightTierBaseWithoutAdditional: 'Without additional weight unit price: base freight = billing weight × matched tier price',
        weightTierBaseWithAdditional: 'With additional weight unit price: base freight = unit price + (billing weight - start weight) × additional weight unit price',
        tripBase: 'Base freight = FTL trip price',
        kmBase: 'Base freight = price per km',
        finalWithMinCharge: 'Total amount = MAX(base freight, min charge) + surcharge total',
        finalWithSurcharge: 'Total amount = base freight + surcharge total',
        surchargeFirstAdditionalConfig: 'First {first} / Additional {additional}',
        fixedSurchargeProcess: 'Fixed fee {amount}',
        firstAdditionalSurchargeProcess: 'First/additional calculation, quantity {quantity}, amount {amount}',
        unitSurchargeProcess: '{unitRate} × {quantity}'
      },
      calculationWarnings: {
        CONTEXT_REQUIRED: 'Missing query context. Default conditions were used.',
        WEIGHT_REQUIRED: 'Billing weight is missing. Weight-based fees cannot be calculated.',
        SIZE_REQUIRED: 'Dimensions are missing. Volumetric weight cannot be calculated.',
        PIECES_REQUIRED: 'Pieces are missing. Volumetric weight or piece-based fees cannot be calculated.',
        VOLUME_REQUIRED: 'Total volume is missing. Volume-based fees cannot be calculated.',
        PRICE_DETAIL_REQUIRED: 'Billing detail is missing. Base freight cannot be calculated.',
        WEIGHT_TIER_NOT_MATCHED: 'No matching weight tier was found.',
        SURCHARGE_MEASURE_REQUIRED: 'The surcharge unit could not be resolved, so weight billing cannot be determined.',
        SURCHARGE_PERCENTAGE_INVALID: 'Fuel surcharge percentage must be between 0 and 100.',
        SURCHARGE_PERCENTAGE_NOT_ALLOWED: 'Percentage billing is not allowed for non-fuel surcharges.'
      },
      association: {
        title: 'Link Consignment',
        searchPlaceholder: 'Enter consignment no.',
        feePreviewTitle: 'Fee Confirmation',
        feeDetailTitle: 'Fees to Import',
        totalLabel: 'Total Amount',
        confirmImportTip: 'The following fees will be imported into the consignment payable fees after confirmation.',
        alreadyAssociated: 'Linked',
        currentAssociated: 'Linked to Current Rate',
        canAssociate: 'Available',
        existingPayableFees: 'The current consignment already has payable fees. This action only creates the link and will not write fees.',
        cancelConfirmTitle: 'Cancel Link',
        cancelConfirmContent: 'Canceling the link will not delete fees already written to the consignment. Continue?',
        actions: {
          associate: 'Link'
        },
        units: {
          pieces: ' pcs',
          weight: ' kg'
        },
        columns: {
          consignmentNo: 'Consignment No.',
          businessType: 'Business Type',
          route: 'Route',
          origin: 'Origin',
          destination: 'Destination',
          cargoInfo: 'Cargo Info',
          orderStatus: 'Consignment Status',
          supplierName: 'Supplier',
          associationStatus: 'Link Status',
          associatedPriceNo: 'Linked Rate No.',
          feeName: 'Fee Name',
          feeSource: 'Fee Source',
          settlementObject: 'Settlement Object',
          quantity: 'Quantity',
          unitPrice: 'Unit Price',
          amount: 'Amount',
          remarks: 'Remarks',
          actions: 'Actions'
        },
        feeSource: {
          BASE_FREIGHT: 'Base Freight',
          MANUAL: 'Manual Surcharge',
          SYSTEM: 'System Surcharge'
        },
        messages: {
          fetchFailed: 'Failed to query consignments',
          previewFailed: 'Failed to preview fees',
          confirmFailed: 'Failed to link consignment',
          cancelFailed: 'Failed to cancel link',
          keywordRequired: 'Enter a consignment no. before searching',
          noConsignmentFound: 'No matching consignment found',
          searchPrompt: 'Search by consignment no.',
          associationSuccess: 'Linked successfully. {count} payable fees were written',
          associationSuccessSkipped: 'Linked successfully. Payable fee writing was skipped because the consignment already has payable fees',
          cancelSuccess: 'Link canceled successfully'
        }
      },
      columns: {
        priceNo: 'Rate No.',
        carrier: 'Express Carrier',
        serviceType: 'Service Type',
        loadMode: 'Load Mode',
        cargoType: 'Cargo Type',
        origin: 'Origin',
        destination: 'Destination',
        billingModel: 'Billing Model',
        billingDetail: 'Billing Detail',
        surcharge: 'Surcharge',
        totalAmount: 'Total Amount',
        validity: 'Validity',
        actions: 'Actions'
      },
      enums: {
        surchargeBillingMode: {
          FIRST_ADDITIONAL: 'First + Additional',
          UNIT_PRICE: 'Unit Price',
          FIXED: 'Fixed Fee'
        }
      }
    }
  }
}
